<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content">
            <ul class="iconlist text-center">
              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-angry-monster"></i>
                  </div>
                  <span> angry-monster </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bathtub"></i>
                  </div>
                  <span> bathtub </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bird-wings"></i>
                  </div>
                  <span> bird-wings </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bow"></i>
                  </div>
                  <span> bow </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-castle"></i>
                  </div>
                  <span> castle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-circuit"></i>
                  </div>
                  <span> circuit </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crown-king"></i>
                  </div>
                  <span> crown-king </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crown-queen"></i>
                  </div>
                  <span> crown-queen </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dart"></i>
                  </div>
                  <span> dart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-disability-race"></i>
                  </div>
                  <span> disability-race </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-diving-goggle"></i>
                  </div>
                  <span> diving-goggle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eye-open"></i>
                  </div>
                  <span> eye-open </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flora-flower"></i>
                  </div>
                  <span> flora-flower </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flora"></i>
                  </div>
                  <span> flora </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gift-box"></i>
                  </div>
                  <span> gift-box </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-halloween-pumpkin"></i>
                  </div>
                  <span> halloween-pumpkin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-power"></i>
                  </div>
                  <span> hand-power </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-thunder"></i>
                  </div>
                  <span> hand-thunder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-king-monster"></i>
                  </div>
                  <span> king-monster </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-love"></i>
                  </div>
                  <span> love </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-magician-hat"></i>
                  </div>
                  <span> magician-hat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-native-american"></i>
                  </div>
                  <span> native-american </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-owl-look"></i>
                  </div>
                  <span> owl-look </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-phoenix"></i>
                  </div>
                  <span> phoenix </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-robot-face"></i>
                  </div>
                  <span> robot-face </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sand-clock"></i>
                  </div>
                  <span> sand-clock </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-shield-alt"></i>
                  </div>
                  <span> shield-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ship-wheel"></i>
                  </div>
                  <span> ship-wheel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-skull-danger"></i>
                  </div>
                  <span> skull-danger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-skull-face"></i>
                  </div>
                  <span> skull-face </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowmobile"></i>
                  </div>
                  <span> snowmobile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-space-shuttle"></i>
                  </div>
                  <span> space-shuttle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-star-shape"></i>
                  </div>
                  <span> star-shape </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-swirl"></i>
                  </div>
                  <span> swirl </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tattoo-wing"></i>
                  </div>
                  <span> tattoo-wing </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-throne"></i>
                  </div>
                  <span> throne </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tree-alt"></i>
                  </div>
                  <span> tree-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-triangle"></i>
                  </div>
                  <span> triangle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-unity-hand"></i>
                  </div>
                  <span> unity-hand </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-weed"></i>
                  </div>
                  <span> weed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-woman-bird"></i>
                  </div>
                  <span> woman-bird </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bat"></i>
                  </div>
                  <span> bat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bear-face"></i>
                  </div>
                  <span> bear-face </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bear-tracks"></i>
                  </div>
                  <span> bear-tracks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bear"></i>
                  </div>
                  <span> bear </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bird-alt"></i>
                  </div>
                  <span> bird-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bird-flying"></i>
                  </div>
                  <span> bird-flying </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bird"></i>
                  </div>
                  <span> bird </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-birds"></i>
                  </div>
                  <span> birds </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bone"></i>
                  </div>
                  <span> bone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bull"></i>
                  </div>
                  <span> bull </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-butterfly-alt"></i>
                  </div>
                  <span> butterfly-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-butterfly"></i>
                  </div>
                  <span> butterfly </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-camel-alt"></i>
                  </div>
                  <span> camel-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-camel-head"></i>
                  </div>
                  <span> camel-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-camel"></i>
                  </div>
                  <span> camel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cat-alt-1"></i>
                  </div>
                  <span> cat-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cat-alt-2"></i>
                  </div>
                  <span> cat-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cat-alt-3"></i>
                  </div>
                  <span> cat-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cat-dog"></i>
                  </div>
                  <span> cat-dog </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cat-face"></i>
                  </div>
                  <span> cat-face </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cat"></i>
                  </div>
                  <span> cat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cow-head"></i>
                  </div>
                  <span> cow-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cow"></i>
                  </div>
                  <span> cow </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crab"></i>
                  </div>
                  <span> crab </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crocodile"></i>
                  </div>
                  <span> crocodile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-deer-head"></i>
                  </div>
                  <span> deer-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dog-alt"></i>
                  </div>
                  <span> dog-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dog-barking"></i>
                  </div>
                  <span> dog-barking </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dog"></i>
                  </div>
                  <span> dog </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dolphin"></i>
                  </div>
                  <span> dolphin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-duck-tracks"></i>
                  </div>
                  <span> duck-tracks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eagle-head"></i>
                  </div>
                  <span> eagle-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eaten-fish"></i>
                  </div>
                  <span> eaten-fish </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-elephant-alt"></i>
                  </div>
                  <span> elephant-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-elephant-head-alt"></i>
                  </div>
                  <span> elephant-head-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-elephant-head"></i>
                  </div>
                  <span> elephant-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-elephant"></i>
                  </div>
                  <span> elephant </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-elk"></i>
                  </div>
                  <span> elk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fish-1"></i>
                  </div>
                  <span> fish-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fish-2"></i>
                  </div>
                  <span> fish-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fish-3"></i>
                  </div>
                  <span> fish-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fish-4"></i>
                  </div>
                  <span> fish-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fish-5"></i>
                  </div>
                  <span> fish-5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fish"></i>
                  </div>
                  <span> fish </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fox-alt"></i>
                  </div>
                  <span> fox-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fox"></i>
                  </div>
                  <span> fox </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-frog-tracks"></i>
                  </div>
                  <span> frog-tracks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-frog"></i>
                  </div>
                  <span> frog </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-froggy"></i>
                  </div>
                  <span> froggy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-giraffe-head-1"></i>
                  </div>
                  <span> giraffe-head-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-giraffe-head-2"></i>
                  </div>
                  <span> giraffe-head-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-giraffe-head"></i>
                  </div>
                  <span> giraffe-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-giraffe"></i>
                  </div>
                  <span> giraffe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-goat-head"></i>
                  </div>
                  <span> goat-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gorilla"></i>
                  </div>
                  <span> gorilla </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hen-tracks"></i>
                  </div>
                  <span> hen-tracks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-horse-head-1"></i>
                  </div>
                  <span> horse-head-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-horse-head-2"></i>
                  </div>
                  <span> horse-head-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-horse-head"></i>
                  </div>
                  <span> horse-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-horse-tracks"></i>
                  </div>
                  <span> horse-tracks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jellyfish"></i>
                  </div>
                  <span> jellyfish </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kangaroo"></i>
                  </div>
                  <span> kangaroo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lemur"></i>
                  </div>
                  <span> lemur </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lion-head-1"></i>
                  </div>
                  <span> lion-head-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lion-head-2"></i>
                  </div>
                  <span> lion-head-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lion-head"></i>
                  </div>
                  <span> lion-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lion"></i>
                  </div>
                  <span> lion </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-monkey-2"></i>
                  </div>
                  <span> monkey-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-monkey-3"></i>
                  </div>
                  <span> monkey-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-monkey-face"></i>
                  </div>
                  <span> monkey-face </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-monkey"></i>
                  </div>
                  <span> monkey </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-octopus-alt"></i>
                  </div>
                  <span> octopus-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-octopus"></i>
                  </div>
                  <span> octopus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-owl"></i>
                  </div>
                  <span> owl </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-panda-face"></i>
                  </div>
                  <span> panda-face </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-panda"></i>
                  </div>
                  <span> panda </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-panther"></i>
                  </div>
                  <span> panther </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-parrot-lip"></i>
                  </div>
                  <span> parrot-lip </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-parrot"></i>
                  </div>
                  <span> parrot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paw"></i>
                  </div>
                  <span> paw </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pelican"></i>
                  </div>
                  <span> pelican </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-penguin"></i>
                  </div>
                  <span> penguin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pig-face"></i>
                  </div>
                  <span> pig-face </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pig"></i>
                  </div>
                  <span> pig </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pigeon-1"></i>
                  </div>
                  <span> pigeon-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pigeon-2"></i>
                  </div>
                  <span> pigeon-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pigeon"></i>
                  </div>
                  <span> pigeon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rabbit"></i>
                  </div>
                  <span> rabbit </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rat"></i>
                  </div>
                  <span> rat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rhino-head"></i>
                  </div>
                  <span> rhino-head </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rhino"></i>
                  </div>
                  <span> rhino </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rooster"></i>
                  </div>
                  <span> rooster </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-seahorse"></i>
                  </div>
                  <span> seahorse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-seal"></i>
                  </div>
                  <span> seal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-shrimp-alt"></i>
                  </div>
                  <span> shrimp-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-shrimp"></i>
                  </div>
                  <span> shrimp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snail-1"></i>
                  </div>
                  <span> snail-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snail-2"></i>
                  </div>
                  <span> snail-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snail-3"></i>
                  </div>
                  <span> snail-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snail"></i>
                  </div>
                  <span> snail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snake"></i>
                  </div>
                  <span> snake </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-squid"></i>
                  </div>
                  <span> squid </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-squirrel"></i>
                  </div>
                  <span> squirrel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tiger-face"></i>
                  </div>
                  <span> tiger-face </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tiger"></i>
                  </div>
                  <span> tiger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-turtle"></i>
                  </div>
                  <span> turtle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-whale"></i>
                  </div>
                  <span> whale </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-woodpecker"></i>
                  </div>
                  <span> woodpecker </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-zebra"></i>
                  </div>
                  <span> zebra </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-acer"></i>
                  </div>
                  <span> brand-acer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-adidas"></i>
                  </div>
                  <span> brand-adidas </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-adobe"></i>
                  </div>
                  <span> brand-adobe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-air-new-zealand"></i>
                  </div>
                  <span> brand-air-new-zealand </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-airbnb"></i>
                  </div>
                  <span> brand-airbnb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-aircell"></i>
                  </div>
                  <span> brand-aircell </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-airtel"></i>
                  </div>
                  <span> brand-airtel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-alcatel"></i>
                  </div>
                  <span> brand-alcatel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-alibaba"></i>
                  </div>
                  <span> brand-alibaba </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-aliexpress"></i>
                  </div>
                  <span> brand-aliexpress </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-alipay"></i>
                  </div>
                  <span> brand-alipay </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-amazon"></i>
                  </div>
                  <span> brand-amazon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-amd"></i>
                  </div>
                  <span> brand-amd </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-american-airlines"></i>
                  </div>
                  <span> brand-american-airlines </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-android-robot"></i>
                  </div>
                  <span> brand-android-robot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-android"></i>
                  </div>
                  <span> brand-android </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-aol"></i>
                  </div>
                  <span> brand-aol </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-apple"></i>
                  </div>
                  <span> brand-apple </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-appstore"></i>
                  </div>
                  <span> brand-appstore </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-asus"></i>
                  </div>
                  <span> brand-asus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-ati"></i>
                  </div>
                  <span> brand-ati </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-att"></i>
                  </div>
                  <span> brand-att </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-audi"></i>
                  </div>
                  <span> brand-audi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-axiata"></i>
                  </div>
                  <span> brand-axiata </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-bada"></i>
                  </div>
                  <span> brand-bada </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-bbc"></i>
                  </div>
                  <span> brand-bbc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-bing"></i>
                  </div>
                  <span> brand-bing </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-blackberry"></i>
                  </div>
                  <span> brand-blackberry </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-bmw"></i>
                  </div>
                  <span> brand-bmw </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-box"></i>
                  </div>
                  <span> brand-box </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-burger-king"></i>
                  </div>
                  <span> brand-burger-king </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-business-insider"></i>
                  </div>
                  <span> brand-business-insider </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-buzzfeed"></i>
                  </div>
                  <span> brand-buzzfeed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-cannon"></i>
                  </div>
                  <span> brand-cannon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-casio"></i>
                  </div>
                  <span> brand-casio </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-china-mobile"></i>
                  </div>
                  <span> brand-china-mobile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-china-telecom"></i>
                  </div>
                  <span> brand-china-telecom </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-china-unicom"></i>
                  </div>
                  <span> brand-china-unicom </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-cisco"></i>
                  </div>
                  <span> brand-cisco </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-citibank"></i>
                  </div>
                  <span> brand-citibank </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-cnet"></i>
                  </div>
                  <span> brand-cnet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-cnn"></i>
                  </div>
                  <span> brand-cnn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-cocal-cola"></i>
                  </div>
                  <span> brand-cocal-cola </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-compaq"></i>
                  </div>
                  <span> brand-compaq </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-debian"></i>
                  </div>
                  <span> brand-debian </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-delicious"></i>
                  </div>
                  <span> brand-delicious </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-dell"></i>
                  </div>
                  <span> brand-dell </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-designbump"></i>
                  </div>
                  <span> brand-designbump </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-designfloat"></i>
                  </div>
                  <span> brand-designfloat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-disney"></i>
                  </div>
                  <span> brand-disney </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-dodge"></i>
                  </div>
                  <span> brand-dodge </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-dove"></i>
                  </div>
                  <span> brand-dove </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-drupal"></i>
                  </div>
                  <span> brand-drupal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-ebay"></i>
                  </div>
                  <span> brand-ebay </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-eleven"></i>
                  </div>
                  <span> brand-eleven </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-emirates"></i>
                  </div>
                  <span> brand-emirates </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-espn"></i>
                  </div>
                  <span> brand-espn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-etihad-airways"></i>
                  </div>
                  <span> brand-etihad-airways </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-etisalat"></i>
                  </div>
                  <span> brand-etisalat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-etsy"></i>
                  </div>
                  <span> brand-etsy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-fastrack"></i>
                  </div>
                  <span> brand-fastrack </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-fedex"></i>
                  </div>
                  <span> brand-fedex </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-ferrari"></i>
                  </div>
                  <span> brand-ferrari </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-fitbit"></i>
                  </div>
                  <span> brand-fitbit </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-flikr"></i>
                  </div>
                  <span> brand-flikr </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-forbes"></i>
                  </div>
                  <span> brand-forbes </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-foursquare"></i>
                  </div>
                  <span> brand-foursquare </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-foxconn"></i>
                  </div>
                  <span> brand-foxconn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-fujitsu"></i>
                  </div>
                  <span> brand-fujitsu </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-general-electric"></i>
                  </div>
                  <span> brand-general-electric </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-gillette"></i>
                  </div>
                  <span> brand-gillette </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-gizmodo"></i>
                  </div>
                  <span> brand-gizmodo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-gnome"></i>
                  </div>
                  <span> brand-gnome </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-google"></i>
                  </div>
                  <span> brand-google </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-gopro"></i>
                  </div>
                  <span> brand-gopro </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-gucci"></i>
                  </div>
                  <span> brand-gucci </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-hallmark"></i>
                  </div>
                  <span> brand-hallmark </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-hi5"></i>
                  </div>
                  <span> brand-hi5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-honda"></i>
                  </div>
                  <span> brand-honda </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-hp"></i>
                  </div>
                  <span> brand-hp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-hsbc"></i>
                  </div>
                  <span> brand-hsbc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-htc"></i>
                  </div>
                  <span> brand-htc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-huawei"></i>
                  </div>
                  <span> brand-huawei </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-hulu"></i>
                  </div>
                  <span> brand-hulu </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-hyundai"></i>
                  </div>
                  <span> brand-hyundai </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-ibm"></i>
                  </div>
                  <span> brand-ibm </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-icofont"></i>
                  </div>
                  <span> brand-icofont </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-icq"></i>
                  </div>
                  <span> brand-icq </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-ikea"></i>
                  </div>
                  <span> brand-ikea </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-imdb"></i>
                  </div>
                  <span> brand-imdb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-indiegogo"></i>
                  </div>
                  <span> brand-indiegogo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-intel"></i>
                  </div>
                  <span> brand-intel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-ipair"></i>
                  </div>
                  <span> brand-ipair </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-jaguar"></i>
                  </div>
                  <span> brand-jaguar </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-java"></i>
                  </div>
                  <span> brand-java </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-joomla"></i>
                  </div>
                  <span> brand-joomla </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-kickstarter"></i>
                  </div>
                  <span> brand-kickstarter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-kik"></i>
                  </div>
                  <span> brand-kik </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-lastfm"></i>
                  </div>
                  <span> brand-lastfm </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-lego"></i>
                  </div>
                  <span> brand-lego </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-lenovo"></i>
                  </div>
                  <span> brand-lenovo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-levis"></i>
                  </div>
                  <span> brand-levis </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-lexus"></i>
                  </div>
                  <span> brand-lexus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-lg"></i>
                  </div>
                  <span> brand-lg </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-life-hacker"></i>
                  </div>
                  <span> brand-life-hacker </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-linux-mint"></i>
                  </div>
                  <span> brand-linux-mint </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-linux"></i>
                  </div>
                  <span> brand-linux </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-lionix"></i>
                  </div>
                  <span> brand-lionix </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-loreal"></i>
                  </div>
                  <span> brand-loreal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-louis-vuitton"></i>
                  </div>
                  <span> brand-louis-vuitton </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mac-os"></i>
                  </div>
                  <span> brand-mac-os </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-marvel-app"></i>
                  </div>
                  <span> brand-marvel-app </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mashable"></i>
                  </div>
                  <span> brand-mashable </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mazda"></i>
                  </div>
                  <span> brand-mazda </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mcdonals"></i>
                  </div>
                  <span> brand-mcdonals </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mercedes"></i>
                  </div>
                  <span> brand-mercedes </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-micromax"></i>
                  </div>
                  <span> brand-micromax </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-microsoft"></i>
                  </div>
                  <span> brand-microsoft </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mobileme"></i>
                  </div>
                  <span> brand-mobileme </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mobily"></i>
                  </div>
                  <span> brand-mobily </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-motorola"></i>
                  </div>
                  <span> brand-motorola </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-msi"></i>
                  </div>
                  <span> brand-msi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mts"></i>
                  </div>
                  <span> brand-mts </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-myspace"></i>
                  </div>
                  <span> brand-myspace </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-mytv"></i>
                  </div>
                  <span> brand-mytv </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-nasa"></i>
                  </div>
                  <span> brand-nasa </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-natgeo"></i>
                  </div>
                  <span> brand-natgeo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-nbc"></i>
                  </div>
                  <span> brand-nbc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-nescafe"></i>
                  </div>
                  <span> brand-nescafe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-nestle"></i>
                  </div>
                  <span> brand-nestle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-netflix"></i>
                  </div>
                  <span> brand-netflix </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-nexus"></i>
                  </div>
                  <span> brand-nexus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-nike"></i>
                  </div>
                  <span> brand-nike </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-nokia"></i>
                  </div>
                  <span> brand-nokia </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-nvidia"></i>
                  </div>
                  <span> brand-nvidia </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-omega"></i>
                  </div>
                  <span> brand-omega </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-opensuse"></i>
                  </div>
                  <span> brand-opensuse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-oracle"></i>
                  </div>
                  <span> brand-oracle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-panasonic"></i>
                  </div>
                  <span> brand-panasonic </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-paypal"></i>
                  </div>
                  <span> brand-paypal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-pepsi"></i>
                  </div>
                  <span> brand-pepsi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-philips"></i>
                  </div>
                  <span> brand-philips </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-pizza-hut"></i>
                  </div>
                  <span> brand-pizza-hut </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-playstation"></i>
                  </div>
                  <span> brand-playstation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-puma"></i>
                  </div>
                  <span> brand-puma </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-qatar-air"></i>
                  </div>
                  <span> brand-qatar-air </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-qvc"></i>
                  </div>
                  <span> brand-qvc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-readernaut"></i>
                  </div>
                  <span> brand-readernaut </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-redbull"></i>
                  </div>
                  <span> brand-redbull </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-reebok"></i>
                  </div>
                  <span> brand-reebok </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-reuters"></i>
                  </div>
                  <span> brand-reuters </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-samsung"></i>
                  </div>
                  <span> brand-samsung </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-sap"></i>
                  </div>
                  <span> brand-sap </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-saudia-airlines"></i>
                  </div>
                  <span> brand-saudia-airlines </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-scribd"></i>
                  </div>
                  <span> brand-scribd </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-shell"></i>
                  </div>
                  <span> brand-shell </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-siemens"></i>
                  </div>
                  <span> brand-siemens </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-sk-telecom"></i>
                  </div>
                  <span> brand-sk-telecom </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-slideshare"></i>
                  </div>
                  <span> brand-slideshare </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-smashing-magazine"></i>
                  </div>
                  <span> brand-smashing-magazine </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-snapchat"></i>
                  </div>
                  <span> brand-snapchat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-sony-ericsson"></i>
                  </div>
                  <span> brand-sony-ericsson </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-sony"></i>
                  </div>
                  <span> brand-sony </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-soundcloud"></i>
                  </div>
                  <span> brand-soundcloud </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-sprint"></i>
                  </div>
                  <span> brand-sprint </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-squidoo"></i>
                  </div>
                  <span> brand-squidoo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-starbucks"></i>
                  </div>
                  <span> brand-starbucks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-stc"></i>
                  </div>
                  <span> brand-stc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-steam"></i>
                  </div>
                  <span> brand-steam </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-suzuki"></i>
                  </div>
                  <span> brand-suzuki </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-symbian"></i>
                  </div>
                  <span> brand-symbian </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-t-mobile"></i>
                  </div>
                  <span> brand-t-mobile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-tango"></i>
                  </div>
                  <span> brand-tango </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-target"></i>
                  </div>
                  <span> brand-target </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-tata-indicom"></i>
                  </div>
                  <span> brand-tata-indicom </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-techcrunch"></i>
                  </div>
                  <span> brand-techcrunch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-telenor"></i>
                  </div>
                  <span> brand-telenor </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-teliasonera"></i>
                  </div>
                  <span> brand-teliasonera </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-tesla"></i>
                  </div>
                  <span> brand-tesla </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-the-verge"></i>
                  </div>
                  <span> brand-the-verge </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-thenextweb"></i>
                  </div>
                  <span> brand-thenextweb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-toshiba"></i>
                  </div>
                  <span> brand-toshiba </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-toyota"></i>
                  </div>
                  <span> brand-toyota </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-tribenet"></i>
                  </div>
                  <span> brand-tribenet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-ubuntu"></i>
                  </div>
                  <span> brand-ubuntu </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-unilever"></i>
                  </div>
                  <span> brand-unilever </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-vaio"></i>
                  </div>
                  <span> brand-vaio </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-verizon"></i>
                  </div>
                  <span> brand-verizon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-viber"></i>
                  </div>
                  <span> brand-viber </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-vodafone"></i>
                  </div>
                  <span> brand-vodafone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-volkswagen"></i>
                  </div>
                  <span> brand-volkswagen </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-walmart"></i>
                  </div>
                  <span> brand-walmart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-warnerbros"></i>
                  </div>
                  <span> brand-warnerbros </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-whatsapp"></i>
                  </div>
                  <span> brand-whatsapp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-wikipedia"></i>
                  </div>
                  <span> brand-wikipedia </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-windows"></i>
                  </div>
                  <span> brand-windows </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-wire"></i>
                  </div>
                  <span> brand-wire </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-wordpress"></i>
                  </div>
                  <span> brand-wordpress </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-xiaomi"></i>
                  </div>
                  <span> brand-xiaomi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-yahoobuzz"></i>
                  </div>
                  <span> brand-yahoobuzz </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-yamaha"></i>
                  </div>
                  <span> brand-yamaha </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-youtube"></i>
                  </div>
                  <span> brand-youtube </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brand-zain"></i>
                  </div>
                  <span> brand-zain </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bank-alt"></i>
                  </div>
                  <span> bank-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bank"></i>
                  </div>
                  <span> bank </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-barcode"></i>
                  </div>
                  <span> barcode </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bill-alt"></i>
                  </div>
                  <span> bill-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-billboard"></i>
                  </div>
                  <span> billboard </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-briefcase-1"></i>
                  </div>
                  <span> briefcase-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-briefcase-2"></i>
                  </div>
                  <span> briefcase-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-businessman"></i>
                  </div>
                  <span> businessman </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-businesswoman"></i>
                  </div>
                  <span> businesswoman </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chair"></i>
                  </div>
                  <span> chair </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-coins"></i>
                  </div>
                  <span> coins </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-company"></i>
                  </div>
                  <span> company </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-contact-add"></i>
                  </div>
                  <span> contact-add </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-files-stack"></i>
                  </div>
                  <span> files-stack </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-handshake-deal"></i>
                  </div>
                  <span> handshake-deal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-id-card"></i>
                  </div>
                  <span> id-card </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-meeting-add"></i>
                  </div>
                  <span> meeting-add </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-money-bag"></i>
                  </div>
                  <span> money-bag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pie-chart"></i>
                  </div>
                  <span> pie-chart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-presentation-alt"></i>
                  </div>
                  <span> presentation-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-presentation"></i>
                  </div>
                  <span> presentation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stamp"></i>
                  </div>
                  <span> stamp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stock-mobile"></i>
                  </div>
                  <span> stock-mobile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-arrows-axis"></i>
                  </div>
                  <span> chart-arrows-axis </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-bar-graph"></i>
                  </div>
                  <span> chart-bar-graph </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-flow-1"></i>
                  </div>
                  <span> chart-flow-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-flow-2"></i>
                  </div>
                  <span> chart-flow-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-flow"></i>
                  </div>
                  <span> chart-flow </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-growth"></i>
                  </div>
                  <span> chart-growth </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-histogram-alt"></i>
                  </div>
                  <span> chart-histogram-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-histogram"></i>
                  </div>
                  <span> chart-histogram </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-line-alt"></i>
                  </div>
                  <span> chart-line-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-line"></i>
                  </div>
                  <span> chart-line </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-pie-alt"></i>
                  </div>
                  <span> chart-pie-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-pie"></i>
                  </div>
                  <span> chart-pie </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chart-radar-graph"></i>
                  </div>
                  <span> chart-radar-graph </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-architecture-alt"></i>
                  </div>
                  <span> architecture-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-architecture"></i>
                  </div>
                  <span> architecture </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-barricade"></i>
                  </div>
                  <span> barricade </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bolt"></i>
                  </div>
                  <span> bolt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bricks"></i>
                  </div>
                  <span> bricks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-building-alt"></i>
                  </div>
                  <span> building-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bull-dozer"></i>
                  </div>
                  <span> bull-dozer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-calculations"></i>
                  </div>
                  <span> calculations </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cement-mix"></i>
                  </div>
                  <span> cement-mix </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cement-mixer"></i>
                  </div>
                  <span> cement-mixer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-concrete-mixer"></i>
                  </div>
                  <span> concrete-mixer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-danger-zone"></i>
                  </div>
                  <span> danger-zone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-drill"></i>
                  </div>
                  <span> drill </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eco-energy"></i>
                  </div>
                  <span> eco-energy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eco-environmen"></i>
                  </div>
                  <span> eco-environmen </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-energy-air"></i>
                  </div>
                  <span> energy-air </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-energy-oil"></i>
                  </div>
                  <span> energy-oil </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-energy-savings"></i>
                  </div>
                  <span> energy-savings </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-energy-solar"></i>
                  </div>
                  <span> energy-solar </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-energy-water"></i>
                  </div>
                  <span> energy-water </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-engineer"></i>
                  </div>
                  <span> engineer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fire-extinguisher-alt"></i>
                  </div>
                  <span> fire-extinguisher-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fire-extinguisher"></i>
                  </div>
                  <span> fire-extinguisher </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fix-tools"></i>
                  </div>
                  <span> fix-tools </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fork-lift"></i>
                  </div>
                  <span> fork-lift </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-glue-oil"></i>
                  </div>
                  <span> glue-oil </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hammer-alt"></i>
                  </div>
                  <span> hammer-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hammer"></i>
                  </div>
                  <span> hammer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-help-robot"></i>
                  </div>
                  <span> help-robot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-industries-1"></i>
                  </div>
                  <span> industries-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-industries-2"></i>
                  </div>
                  <span> industries-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-industries-3"></i>
                  </div>
                  <span> industries-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-industries-4"></i>
                  </div>
                  <span> industries-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-industries-5"></i>
                  </div>
                  <span> industries-5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-industries"></i>
                  </div>
                  <span> industries </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-labour"></i>
                  </div>
                  <span> labour </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mining"></i>
                  </div>
                  <span> mining </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paint-brush"></i>
                  </div>
                  <span> paint-brush </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pollution"></i>
                  </div>
                  <span> pollution </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-power-zone"></i>
                  </div>
                  <span> power-zone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-radio-active"></i>
                  </div>
                  <span> radio-active </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-recycle-alt"></i>
                  </div>
                  <span> recycle-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-recycling-man"></i>
                  </div>
                  <span> recycling-man </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-safety-hat-light"></i>
                  </div>
                  <span> safety-hat-light </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-safety-hat"></i>
                  </div>
                  <span> safety-hat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-saw"></i>
                  </div>
                  <span> saw </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-screw-driver"></i>
                  </div>
                  <span> screw-driver </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tools-1"></i>
                  </div>
                  <span> tools-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tools-bag"></i>
                  </div>
                  <span> tools-bag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tow-truck"></i>
                  </div>
                  <span> tow-truck </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-trolley"></i>
                  </div>
                  <span> trolley </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-trowel"></i>
                  </div>
                  <span> trowel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-under-construction-alt"></i>
                  </div>
                  <span> under-construction-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-under-construction"></i>
                  </div>
                  <span> under-construction </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vehicle-cement"></i>
                  </div>
                  <span> vehicle-cement </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vehicle-crane"></i>
                  </div>
                  <span> vehicle-crane </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vehicle-delivery-van"></i>
                  </div>
                  <span> vehicle-delivery-van </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vehicle-dozer"></i>
                  </div>
                  <span> vehicle-dozer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vehicle-excavator"></i>
                  </div>
                  <span> vehicle-excavator </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vehicle-trucktor"></i>
                  </div>
                  <span> vehicle-trucktor </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vehicle-wrecking"></i>
                  </div>
                  <span> vehicle-wrecking </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-worker"></i>
                  </div>
                  <span> worker </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-workers-group"></i>
                  </div>
                  <span> workers-group </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wrench"></i>
                  </div>
                  <span> wrench </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-afghani-false"></i>
                  </div>
                  <span> afghani-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-afghani-minus"></i>
                  </div>
                  <span> afghani-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-afghani-plus"></i>
                  </div>
                  <span> afghani-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-afghani-true"></i>
                  </div>
                  <span> afghani-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-afghani"></i>
                  </div>
                  <span> afghani </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baht-false"></i>
                  </div>
                  <span> baht-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baht-minus"></i>
                  </div>
                  <span> baht-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baht-plus"></i>
                  </div>
                  <span> baht-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baht-true"></i>
                  </div>
                  <span> baht-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baht"></i>
                  </div>
                  <span> baht </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bitcoin-false"></i>
                  </div>
                  <span> bitcoin-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bitcoin-minus"></i>
                  </div>
                  <span> bitcoin-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bitcoin-plus"></i>
                  </div>
                  <span> bitcoin-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bitcoin-true"></i>
                  </div>
                  <span> bitcoin-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bitcoin"></i>
                  </div>
                  <span> bitcoin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dollar-flase"></i>
                  </div>
                  <span> dollar-flase </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dollar-minus"></i>
                  </div>
                  <span> dollar-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dollar-plus"></i>
                  </div>
                  <span> dollar-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dollar-true"></i>
                  </div>
                  <span> dollar-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dollar"></i>
                  </div>
                  <span> dollar </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dong-false"></i>
                  </div>
                  <span> dong-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dong-minus"></i>
                  </div>
                  <span> dong-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dong-plus"></i>
                  </div>
                  <span> dong-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dong-true"></i>
                  </div>
                  <span> dong-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dong"></i>
                  </div>
                  <span> dong </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-euro-false"></i>
                  </div>
                  <span> euro-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-euro-minus"></i>
                  </div>
                  <span> euro-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-euro-plus"></i>
                  </div>
                  <span> euro-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-euro-true"></i>
                  </div>
                  <span> euro-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-euro"></i>
                  </div>
                  <span> euro </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-frank-false"></i>
                  </div>
                  <span> frank-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-frank-minus"></i>
                  </div>
                  <span> frank-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-frank-plus"></i>
                  </div>
                  <span> frank-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-frank-true"></i>
                  </div>
                  <span> frank-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-frank"></i>
                  </div>
                  <span> frank </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hryvnia-false"></i>
                  </div>
                  <span> hryvnia-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hryvnia-minus"></i>
                  </div>
                  <span> hryvnia-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hryvnia-plus"></i>
                  </div>
                  <span> hryvnia-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hryvnia-true"></i>
                  </div>
                  <span> hryvnia-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hryvnia"></i>
                  </div>
                  <span> hryvnia </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lira-false"></i>
                  </div>
                  <span> lira-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lira-minus"></i>
                  </div>
                  <span> lira-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lira-plus"></i>
                  </div>
                  <span> lira-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lira-true"></i>
                  </div>
                  <span> lira-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lira"></i>
                  </div>
                  <span> lira </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peseta-false"></i>
                  </div>
                  <span> peseta-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peseta-minus"></i>
                  </div>
                  <span> peseta-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peseta-plus"></i>
                  </div>
                  <span> peseta-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peseta-true"></i>
                  </div>
                  <span> peseta-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peseta"></i>
                  </div>
                  <span> peseta </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peso-false"></i>
                  </div>
                  <span> peso-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peso-minus"></i>
                  </div>
                  <span> peso-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peso-plus"></i>
                  </div>
                  <span> peso-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peso-true"></i>
                  </div>
                  <span> peso-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peso"></i>
                  </div>
                  <span> peso </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pound-false"></i>
                  </div>
                  <span> pound-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pound-minus"></i>
                  </div>
                  <span> pound-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pound-plus"></i>
                  </div>
                  <span> pound-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pound-true"></i>
                  </div>
                  <span> pound-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pound"></i>
                  </div>
                  <span> pound </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-renminbi-false"></i>
                  </div>
                  <span> renminbi-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-renminbi-minus"></i>
                  </div>
                  <span> renminbi-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-renminbi-plus"></i>
                  </div>
                  <span> renminbi-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-renminbi-true"></i>
                  </div>
                  <span> renminbi-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-renminbi"></i>
                  </div>
                  <span> renminbi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-riyal-false"></i>
                  </div>
                  <span> riyal-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-riyal-minus"></i>
                  </div>
                  <span> riyal-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-riyal-plus"></i>
                  </div>
                  <span> riyal-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-riyal-true"></i>
                  </div>
                  <span> riyal-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-riyal"></i>
                  </div>
                  <span> riyal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rouble-false"></i>
                  </div>
                  <span> rouble-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rouble-minus"></i>
                  </div>
                  <span> rouble-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rouble-plus"></i>
                  </div>
                  <span> rouble-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rouble-true"></i>
                  </div>
                  <span> rouble-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rouble"></i>
                  </div>
                  <span> rouble </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rupee-false"></i>
                  </div>
                  <span> rupee-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rupee-minus"></i>
                  </div>
                  <span> rupee-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rupee-plus"></i>
                  </div>
                  <span> rupee-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rupee-true"></i>
                  </div>
                  <span> rupee-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rupee"></i>
                  </div>
                  <span> rupee </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-taka-false"></i>
                  </div>
                  <span> taka-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-taka-minus"></i>
                  </div>
                  <span> taka-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-taka-plus"></i>
                  </div>
                  <span> taka-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-taka-true"></i>
                  </div>
                  <span> taka-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-taka"></i>
                  </div>
                  <span> taka </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-turkish-lira-false"></i>
                  </div>
                  <span> turkish-lira-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-turkish-lira-minus"></i>
                  </div>
                  <span> turkish-lira-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-turkish-lira-plus"></i>
                  </div>
                  <span> turkish-lira-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-turkish-lira-true"></i>
                  </div>
                  <span> turkish-lira-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-turkish-lira"></i>
                  </div>
                  <span> turkish-lira </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-won-false"></i>
                  </div>
                  <span> won-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-won-minus"></i>
                  </div>
                  <span> won-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-won-plus"></i>
                  </div>
                  <span> won-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-won-true"></i>
                  </div>
                  <span> won-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-won"></i>
                  </div>
                  <span> won </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-yen-false"></i>
                  </div>
                  <span> yen-false </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-yen-minus"></i>
                  </div>
                  <span> yen-minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-yen-plus"></i>
                  </div>
                  <span> yen-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-yen-true"></i>
                  </div>
                  <span> yen-true </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-yen"></i>
                  </div>
                  <span> yen </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-android-nexus"></i>
                  </div>
                  <span> android-nexus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-android-tablet"></i>
                  </div>
                  <span> android-tablet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-apple-watch"></i>
                  </div>
                  <span> apple-watch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-drawing-tablet"></i>
                  </div>
                  <span> drawing-tablet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-earphone"></i>
                  </div>
                  <span> earphone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flash-drive"></i>
                  </div>
                  <span> flash-drive </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-game-console"></i>
                  </div>
                  <span> game-console </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-game-controller"></i>
                  </div>
                  <span> game-controller </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-game-pad"></i>
                  </div>
                  <span> game-pad </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-game"></i>
                  </div>
                  <span> game </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-headphone-alt-1"></i>
                  </div>
                  <span> headphone-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-headphone-alt-2"></i>
                  </div>
                  <span> headphone-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-headphone-alt-3"></i>
                  </div>
                  <span> headphone-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-headphone-alt"></i>
                  </div>
                  <span> headphone-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-headphone"></i>
                  </div>
                  <span> headphone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-htc-one"></i>
                  </div>
                  <span> htc-one </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-imac"></i>
                  </div>
                  <span> imac </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ipad"></i>
                  </div>
                  <span> ipad </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-iphone"></i>
                  </div>
                  <span> iphone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ipod-nano"></i>
                  </div>
                  <span> ipod-nano </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ipod-touch"></i>
                  </div>
                  <span> ipod-touch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-keyboard-alt"></i>
                  </div>
                  <span> keyboard-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-keyboard-wireless"></i>
                  </div>
                  <span> keyboard-wireless </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-keyboard"></i>
                  </div>
                  <span> keyboard </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-laptop-alt"></i>
                  </div>
                  <span> laptop-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-laptop"></i>
                  </div>
                  <span> laptop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-macbook"></i>
                  </div>
                  <span> macbook </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-magic-mouse"></i>
                  </div>
                  <span> magic-mouse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-micro-chip"></i>
                  </div>
                  <span> micro-chip </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-microphone-alt"></i>
                  </div>
                  <span> microphone-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-microphone"></i>
                  </div>
                  <span> microphone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-monitor"></i>
                  </div>
                  <span> monitor </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mouse"></i>
                  </div>
                  <span> mouse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mp3-player"></i>
                  </div>
                  <span> mp3-player </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-nintendo"></i>
                  </div>
                  <span> nintendo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-playstation-alt"></i>
                  </div>
                  <span> playstation-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-psvita"></i>
                  </div>
                  <span> psvita </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-radio-mic"></i>
                  </div>
                  <span> radio-mic </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-radio"></i>
                  </div>
                  <span> radio </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-refrigerator"></i>
                  </div>
                  <span> refrigerator </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-samsung-galaxy"></i>
                  </div>
                  <span> samsung-galaxy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-surface-tablet"></i>
                  </div>
                  <span> surface-tablet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-head-phone"></i>
                  </div>
                  <span> ui-head-phone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-keyboard"></i>
                  </div>
                  <span> ui-keyboard </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-washing-machine"></i>
                  </div>
                  <span> washing-machine </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wifi-router"></i>
                  </div>
                  <span> wifi-router </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wii-u"></i>
                  </div>
                  <span> wii-u </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-windows-lumia"></i>
                  </div>
                  <span> windows-lumia </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wireless-mouse"></i>
                  </div>
                  <span> wireless-mouse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-xbox-360"></i>
                  </div>
                  <span> xbox-360 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-arrow-down"></i>
                  </div>
                  <span> arrow-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-arrow-left"></i>
                  </div>
                  <span> arrow-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-arrow-right"></i>
                  </div>
                  <span> arrow-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-arrow-up"></i>
                  </div>
                  <span> arrow-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-block-down"></i>
                  </div>
                  <span> block-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-block-left"></i>
                  </div>
                  <span> block-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-block-right"></i>
                  </div>
                  <span> block-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-block-up"></i>
                  </div>
                  <span> block-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bubble-down"></i>
                  </div>
                  <span> bubble-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bubble-left"></i>
                  </div>
                  <span> bubble-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bubble-right"></i>
                  </div>
                  <span> bubble-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bubble-up"></i>
                  </div>
                  <span> bubble-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-caret-down"></i>
                  </div>
                  <span> caret-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-caret-left"></i>
                  </div>
                  <span> caret-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-caret-right"></i>
                  </div>
                  <span> caret-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-caret-up"></i>
                  </div>
                  <span> caret-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-circled-down"></i>
                  </div>
                  <span> circled-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-circled-left"></i>
                  </div>
                  <span> circled-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-circled-right"></i>
                  </div>
                  <span> circled-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-circled-up"></i>
                  </div>
                  <span> circled-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-collapse"></i>
                  </div>
                  <span> collapse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cursor-drag"></i>
                  </div>
                  <span> cursor-drag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-curved-double-left"></i>
                  </div>
                  <span> curved-double-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-curved-double-right"></i>
                  </div>
                  <span> curved-double-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-curved-down"></i>
                  </div>
                  <span> curved-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-curved-left"></i>
                  </div>
                  <span> curved-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-curved-right"></i>
                  </div>
                  <span> curved-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-curved-up"></i>
                  </div>
                  <span> curved-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dotted-down"></i>
                  </div>
                  <span> dotted-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dotted-left"></i>
                  </div>
                  <span> dotted-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dotted-right"></i>
                  </div>
                  <span> dotted-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dotted-up"></i>
                  </div>
                  <span> dotted-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-double-left"></i>
                  </div>
                  <span> double-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-double-right"></i>
                  </div>
                  <span> double-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-expand-alt"></i>
                  </div>
                  <span> expand-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-down"></i>
                  </div>
                  <span> hand-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drag"></i>
                  </div>
                  <span> hand-drag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drag1"></i>
                  </div>
                  <span> hand-drag1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drag2"></i>
                  </div>
                  <span> hand-drag2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drawn-alt-down"></i>
                  </div>
                  <span> hand-drawn-alt-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drawn-alt-left"></i>
                  </div>
                  <span> hand-drawn-alt-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drawn-alt-right"></i>
                  </div>
                  <span> hand-drawn-alt-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drawn-alt-up"></i>
                  </div>
                  <span> hand-drawn-alt-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drawn-down"></i>
                  </div>
                  <span> hand-drawn-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drawn-left"></i>
                  </div>
                  <span> hand-drawn-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drawn-right"></i>
                  </div>
                  <span> hand-drawn-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-drawn-up"></i>
                  </div>
                  <span> hand-drawn-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-grippers"></i>
                  </div>
                  <span> hand-grippers </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-left"></i>
                  </div>
                  <span> hand-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-right"></i>
                  </div>
                  <span> hand-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand-up"></i>
                  </div>
                  <span> hand-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-line-block-down"></i>
                  </div>
                  <span> line-block-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-line-block-left"></i>
                  </div>
                  <span> line-block-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-line-block-right"></i>
                  </div>
                  <span> line-block-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-line-block-up"></i>
                  </div>
                  <span> line-block-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-long-arrow-down"></i>
                  </div>
                  <span> long-arrow-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-long-arrow-left"></i>
                  </div>
                  <span> long-arrow-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-long-arrow-right"></i>
                  </div>
                  <span> long-arrow-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-long-arrow-up"></i>
                  </div>
                  <span> long-arrow-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-collapse"></i>
                  </div>
                  <span> rounded-collapse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-double-left"></i>
                  </div>
                  <span> rounded-double-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-double-right"></i>
                  </div>
                  <span> rounded-double-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-down"></i>
                  </div>
                  <span> rounded-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-expand"></i>
                  </div>
                  <span> rounded-expand </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-left-down"></i>
                  </div>
                  <span> rounded-left-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-left-up"></i>
                  </div>
                  <span> rounded-left-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-left"></i>
                  </div>
                  <span> rounded-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-right-down"></i>
                  </div>
                  <span> rounded-right-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-right-up"></i>
                  </div>
                  <span> rounded-right-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-right"></i>
                  </div>
                  <span> rounded-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rounded-up"></i>
                  </div>
                  <span> rounded-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-bubble-down"></i>
                  </div>
                  <span> scroll-bubble-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-bubble-left"></i>
                  </div>
                  <span> scroll-bubble-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-bubble-right"></i>
                  </div>
                  <span> scroll-bubble-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-bubble-up"></i>
                  </div>
                  <span> scroll-bubble-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-double-down"></i>
                  </div>
                  <span> scroll-double-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-double-left"></i>
                  </div>
                  <span> scroll-double-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-double-right"></i>
                  </div>
                  <span> scroll-double-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-double-up"></i>
                  </div>
                  <span> scroll-double-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-down"></i>
                  </div>
                  <span> scroll-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-left"></i>
                  </div>
                  <span> scroll-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-long-down"></i>
                  </div>
                  <span> scroll-long-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-long-left"></i>
                  </div>
                  <span> scroll-long-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-long-right"></i>
                  </div>
                  <span> scroll-long-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-long-up"></i>
                  </div>
                  <span> scroll-long-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-right"></i>
                  </div>
                  <span> scroll-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scroll-up"></i>
                  </div>
                  <span> scroll-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-down"></i>
                  </div>
                  <span> simple-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-left-down"></i>
                  </div>
                  <span> simple-left-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-left-up"></i>
                  </div>
                  <span> simple-left-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-left"></i>
                  </div>
                  <span> simple-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-right-down"></i>
                  </div>
                  <span> simple-right-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-right-up"></i>
                  </div>
                  <span> simple-right-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-right"></i>
                  </div>
                  <span> simple-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-up"></i>
                  </div>
                  <span> simple-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-square-down"></i>
                  </div>
                  <span> square-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-square-left"></i>
                  </div>
                  <span> square-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-square-right"></i>
                  </div>
                  <span> square-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-square-up"></i>
                  </div>
                  <span> square-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stylish-down"></i>
                  </div>
                  <span> stylish-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stylish-left"></i>
                  </div>
                  <span> stylish-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stylish-right"></i>
                  </div>
                  <span> stylish-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stylish-up"></i>
                  </div>
                  <span> stylish-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-swoosh-down"></i>
                  </div>
                  <span> swoosh-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-swoosh-left"></i>
                  </div>
                  <span> swoosh-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-swoosh-right"></i>
                  </div>
                  <span> swoosh-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-swoosh-up"></i>
                  </div>
                  <span> swoosh-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thin-double-left"></i>
                  </div>
                  <span> thin-double-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thin-double-right"></i>
                  </div>
                  <span> thin-double-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thin-down"></i>
                  </div>
                  <span> thin-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thin-left"></i>
                  </div>
                  <span> thin-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thin-right"></i>
                  </div>
                  <span> thin-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thin-up"></i>
                  </div>
                  <span> thin-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-abc"></i>
                  </div>
                  <span> abc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-atom"></i>
                  </div>
                  <span> atom </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-award"></i>
                  </div>
                  <span> award </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bell-alt"></i>
                  </div>
                  <span> bell-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-black-board"></i>
                  </div>
                  <span> black-board </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-book-alt"></i>
                  </div>
                  <span> book-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-book"></i>
                  </div>
                  <span> book </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brainstorming"></i>
                  </div>
                  <span> brainstorming </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-certificate-alt-1"></i>
                  </div>
                  <span> certificate-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-certificate-alt-2"></i>
                  </div>
                  <span> certificate-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-certificate"></i>
                  </div>
                  <span> certificate </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-education"></i>
                  </div>
                  <span> education </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-electron"></i>
                  </div>
                  <span> electron </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fountain-pen"></i>
                  </div>
                  <span> fountain-pen </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-globe-alt"></i>
                  </div>
                  <span> globe-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-graduate-alt"></i>
                  </div>
                  <span> graduate-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-graduate"></i>
                  </div>
                  <span> graduate </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-group-students"></i>
                  </div>
                  <span> group-students </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hat-alt"></i>
                  </div>
                  <span> hat-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hat"></i>
                  </div>
                  <span> hat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-instrument"></i>
                  </div>
                  <span> instrument </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lamp-light"></i>
                  </div>
                  <span> lamp-light </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-medal"></i>
                  </div>
                  <span> medal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-microscope-alt"></i>
                  </div>
                  <span> microscope-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-microscope"></i>
                  </div>
                  <span> microscope </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paper"></i>
                  </div>
                  <span> paper </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pen-alt-4"></i>
                  </div>
                  <span> pen-alt-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pen-nib"></i>
                  </div>
                  <span> pen-nib </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pencil-alt-5"></i>
                  </div>
                  <span> pencil-alt-5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-quill-pen"></i>
                  </div>
                  <span> quill-pen </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-read-book-alt"></i>
                  </div>
                  <span> read-book-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-read-book"></i>
                  </div>
                  <span> read-book </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-school-bag"></i>
                  </div>
                  <span> school-bag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-school-bus"></i>
                  </div>
                  <span> school-bus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-student-alt"></i>
                  </div>
                  <span> student-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-student"></i>
                  </div>
                  <span> student </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-teacher"></i>
                  </div>
                  <span> teacher </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-test-bulb"></i>
                  </div>
                  <span> test-bulb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-test-tube-alt"></i>
                  </div>
                  <span> test-tube-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-university"></i>
                  </div>
                  <span> university </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-angry"></i>
                  </div>
                  <span> angry </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-astonished"></i>
                  </div>
                  <span> astonished </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-confounded"></i>
                  </div>
                  <span> confounded </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-confused"></i>
                  </div>
                  <span> confused </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crying"></i>
                  </div>
                  <span> crying </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dizzy"></i>
                  </div>
                  <span> dizzy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-expressionless"></i>
                  </div>
                  <span> expressionless </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-heart-eyes"></i>
                  </div>
                  <span> heart-eyes </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-laughing"></i>
                  </div>
                  <span> laughing </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-nerd-smile"></i>
                  </div>
                  <span> nerd-smile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-open-mouth"></i>
                  </div>
                  <span> open-mouth </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rage"></i>
                  </div>
                  <span> rage </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rolling-eyes"></i>
                  </div>
                  <span> rolling-eyes </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sad"></i>
                  </div>
                  <span> sad </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-simple-smile"></i>
                  </div>
                  <span> simple-smile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-slightly-smile"></i>
                  </div>
                  <span> slightly-smile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-smirk"></i>
                  </div>
                  <span> smirk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stuck-out-tongue"></i>
                  </div>
                  <span> stuck-out-tongue </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wink-smile"></i>
                  </div>
                  <span> wink-smile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-worried"></i>
                  </div>
                  <span> worried </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-alt"></i>
                  </div>
                  <span> file-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-audio"></i>
                  </div>
                  <span> file-audio </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-avi-mp4"></i>
                  </div>
                  <span> file-avi-mp4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-bmp"></i>
                  </div>
                  <span> file-bmp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-code"></i>
                  </div>
                  <span> file-code </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-css"></i>
                  </div>
                  <span> file-css </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-document"></i>
                  </div>
                  <span> file-document </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-eps"></i>
                  </div>
                  <span> file-eps </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-excel"></i>
                  </div>
                  <span> file-excel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-exe"></i>
                  </div>
                  <span> file-exe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-file"></i>
                  </div>
                  <span> file-file </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-flv"></i>
                  </div>
                  <span> file-flv </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-gif"></i>
                  </div>
                  <span> file-gif </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-html5"></i>
                  </div>
                  <span> file-html5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-image"></i>
                  </div>
                  <span> file-image </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-iso"></i>
                  </div>
                  <span> file-iso </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-java"></i>
                  </div>
                  <span> file-java </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-javascript"></i>
                  </div>
                  <span> file-javascript </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-jpg"></i>
                  </div>
                  <span> file-jpg </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-midi"></i>
                  </div>
                  <span> file-midi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-mov"></i>
                  </div>
                  <span> file-mov </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-mp3"></i>
                  </div>
                  <span> file-mp3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-pdf"></i>
                  </div>
                  <span> file-pdf </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-php"></i>
                  </div>
                  <span> file-php </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-png"></i>
                  </div>
                  <span> file-png </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-powerpoint"></i>
                  </div>
                  <span> file-powerpoint </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-presentation"></i>
                  </div>
                  <span> file-presentation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-psb"></i>
                  </div>
                  <span> file-psb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-psd"></i>
                  </div>
                  <span> file-psd </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-python"></i>
                  </div>
                  <span> file-python </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-ruby"></i>
                  </div>
                  <span> file-ruby </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-spreadsheet"></i>
                  </div>
                  <span> file-spreadsheet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-sql"></i>
                  </div>
                  <span> file-sql </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-svg"></i>
                  </div>
                  <span> file-svg </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-text"></i>
                  </div>
                  <span> file-text </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-tiff"></i>
                  </div>
                  <span> file-tiff </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-video"></i>
                  </div>
                  <span> file-video </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-wave"></i>
                  </div>
                  <span> file-wave </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-wmv"></i>
                  </div>
                  <span> file-wmv </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-word"></i>
                  </div>
                  <span> file-word </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-zip"></i>
                  </div>
                  <span> file-zip </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cycling-alt"></i>
                  </div>
                  <span> cycling-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cycling"></i>
                  </div>
                  <span> cycling </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dumbbell"></i>
                  </div>
                  <span> dumbbell </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dumbbells"></i>
                  </div>
                  <span> dumbbells </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gym-alt-1"></i>
                  </div>
                  <span> gym-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gym-alt-2"></i>
                  </div>
                  <span> gym-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gym-alt-3"></i>
                  </div>
                  <span> gym-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gym"></i>
                  </div>
                  <span> gym </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-muscle-weight"></i>
                  </div>
                  <span> muscle-weight </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-muscle"></i>
                  </div>
                  <span> muscle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-apple"></i>
                  </div>
                  <span> apple </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-arabian-coffee"></i>
                  </div>
                  <span> arabian-coffee </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-artichoke"></i>
                  </div>
                  <span> artichoke </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-asparagus"></i>
                  </div>
                  <span> asparagus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-avocado"></i>
                  </div>
                  <span> avocado </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baby-food"></i>
                  </div>
                  <span> baby-food </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-banana"></i>
                  </div>
                  <span> banana </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bbq"></i>
                  </div>
                  <span> bbq </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-beans"></i>
                  </div>
                  <span> beans </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-beer"></i>
                  </div>
                  <span> beer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bell-pepper-capsicum"></i>
                  </div>
                  <span> bell-pepper-capsicum </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-birthday-cake"></i>
                  </div>
                  <span> birthday-cake </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bread"></i>
                  </div>
                  <span> bread </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-broccoli"></i>
                  </div>
                  <span> broccoli </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-burger"></i>
                  </div>
                  <span> burger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cabbage"></i>
                  </div>
                  <span> cabbage </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-carrot"></i>
                  </div>
                  <span> carrot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cauli-flower"></i>
                  </div>
                  <span> cauli-flower </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cheese"></i>
                  </div>
                  <span> cheese </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chef"></i>
                  </div>
                  <span> chef </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cherry"></i>
                  </div>
                  <span> cherry </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chicken-fry"></i>
                  </div>
                  <span> chicken-fry </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chicken"></i>
                  </div>
                  <span> chicken </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cocktail"></i>
                  </div>
                  <span> cocktail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-coconut-water"></i>
                  </div>
                  <span> coconut-water </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-coconut"></i>
                  </div>
                  <span> coconut </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-coffee-alt"></i>
                  </div>
                  <span> coffee-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-coffee-cup"></i>
                  </div>
                  <span> coffee-cup </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-coffee-mug"></i>
                  </div>
                  <span> coffee-mug </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-coffee-pot"></i>
                  </div>
                  <span> coffee-pot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cola"></i>
                  </div>
                  <span> cola </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-corn"></i>
                  </div>
                  <span> corn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-croissant"></i>
                  </div>
                  <span> croissant </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crop-plant"></i>
                  </div>
                  <span> crop-plant </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cucumber"></i>
                  </div>
                  <span> cucumber </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-culinary"></i>
                  </div>
                  <span> culinary </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cup-cake"></i>
                  </div>
                  <span> cup-cake </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dining-table"></i>
                  </div>
                  <span> dining-table </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-donut"></i>
                  </div>
                  <span> donut </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-egg-plant"></i>
                  </div>
                  <span> egg-plant </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-egg-poached"></i>
                  </div>
                  <span> egg-poached </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-farmer-alt"></i>
                  </div>
                  <span> farmer-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-farmer"></i>
                  </div>
                  <span> farmer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fast-food"></i>
                  </div>
                  <span> fast-food </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-food-basket"></i>
                  </div>
                  <span> food-basket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-food-cart"></i>
                  </div>
                  <span> food-cart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fork-and-knife"></i>
                  </div>
                  <span> fork-and-knife </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-french-fries"></i>
                  </div>
                  <span> french-fries </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fruits"></i>
                  </div>
                  <span> fruits </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-grapes"></i>
                  </div>
                  <span> grapes </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-honey"></i>
                  </div>
                  <span> honey </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hot-dog"></i>
                  </div>
                  <span> hot-dog </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ice-cream-alt"></i>
                  </div>
                  <span> ice-cream-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ice-cream"></i>
                  </div>
                  <span> ice-cream </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-juice"></i>
                  </div>
                  <span> juice </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ketchup"></i>
                  </div>
                  <span> ketchup </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kiwi"></i>
                  </div>
                  <span> kiwi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-layered-cake"></i>
                  </div>
                  <span> layered-cake </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lemon-alt"></i>
                  </div>
                  <span> lemon-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lemon"></i>
                  </div>
                  <span> lemon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lobster"></i>
                  </div>
                  <span> lobster </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mango"></i>
                  </div>
                  <span> mango </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-milk"></i>
                  </div>
                  <span> milk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mushroom"></i>
                  </div>
                  <span> mushroom </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-noodles"></i>
                  </div>
                  <span> noodles </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-onion"></i>
                  </div>
                  <span> onion </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-orange"></i>
                  </div>
                  <span> orange </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pear"></i>
                  </div>
                  <span> pear </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-peas"></i>
                  </div>
                  <span> peas </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pepper"></i>
                  </div>
                  <span> pepper </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pie-alt"></i>
                  </div>
                  <span> pie-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pie"></i>
                  </div>
                  <span> pie </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pineapple"></i>
                  </div>
                  <span> pineapple </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pizza-slice"></i>
                  </div>
                  <span> pizza-slice </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pizza"></i>
                  </div>
                  <span> pizza </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-plant"></i>
                  </div>
                  <span> plant </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-popcorn"></i>
                  </div>
                  <span> popcorn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-potato"></i>
                  </div>
                  <span> potato </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pumpkin"></i>
                  </div>
                  <span> pumpkin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-raddish"></i>
                  </div>
                  <span> raddish </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-restaurant-menu"></i>
                  </div>
                  <span> restaurant-menu </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-restaurant"></i>
                  </div>
                  <span> restaurant </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-salt-and-pepper"></i>
                  </div>
                  <span> salt-and-pepper </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sandwich"></i>
                  </div>
                  <span> sandwich </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sausage"></i>
                  </div>
                  <span> sausage </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-soft-drinks"></i>
                  </div>
                  <span> soft-drinks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-soup-bowl"></i>
                  </div>
                  <span> soup-bowl </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spoon-and-fork"></i>
                  </div>
                  <span> spoon-and-fork </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-steak"></i>
                  </div>
                  <span> steak </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-strawberry"></i>
                  </div>
                  <span> strawberry </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sub-sandwich"></i>
                  </div>
                  <span> sub-sandwich </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sushi"></i>
                  </div>
                  <span> sushi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-taco"></i>
                  </div>
                  <span> taco </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tea-pot"></i>
                  </div>
                  <span> tea-pot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tea"></i>
                  </div>
                  <span> tea </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tomato"></i>
                  </div>
                  <span> tomato </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-watermelon"></i>
                  </div>
                  <span> watermelon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wheat"></i>
                  </div>
                  <span> wheat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baby-backpack"></i>
                  </div>
                  <span> baby-backpack </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baby-cloth"></i>
                  </div>
                  <span> baby-cloth </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baby-milk-bottle"></i>
                  </div>
                  <span> baby-milk-bottle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baby-trolley"></i>
                  </div>
                  <span> baby-trolley </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baby"></i>
                  </div>
                  <span> baby </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-candy"></i>
                  </div>
                  <span> candy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-holding-hands"></i>
                  </div>
                  <span> holding-hands </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-infant-nipple"></i>
                  </div>
                  <span> infant-nipple </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kids-scooter"></i>
                  </div>
                  <span> kids-scooter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-safety-pin"></i>
                  </div>
                  <span> safety-pin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-teddy-bear"></i>
                  </div>
                  <span> teddy-bear </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toy-ball"></i>
                  </div>
                  <span> toy-ball </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toy-cat"></i>
                  </div>
                  <span> toy-cat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toy-duck"></i>
                  </div>
                  <span> toy-duck </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toy-elephant"></i>
                  </div>
                  <span> toy-elephant </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toy-hand"></i>
                  </div>
                  <span> toy-hand </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toy-horse"></i>
                  </div>
                  <span> toy-horse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toy-lattu"></i>
                  </div>
                  <span> toy-lattu </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toy-train"></i>
                  </div>
                  <span> toy-train </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-burglar"></i>
                  </div>
                  <span> burglar </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cannon-firing"></i>
                  </div>
                  <span> cannon-firing </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cc-camera"></i>
                  </div>
                  <span> cc-camera </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cop-badge"></i>
                  </div>
                  <span> cop-badge </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cop"></i>
                  </div>
                  <span> cop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-court-hammer"></i>
                  </div>
                  <span> court-hammer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-court"></i>
                  </div>
                  <span> court </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-finger-print"></i>
                  </div>
                  <span> finger-print </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gavel"></i>
                  </div>
                  <span> gavel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-handcuff-alt"></i>
                  </div>
                  <span> handcuff-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-handcuff"></i>
                  </div>
                  <span> handcuff </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-investigation"></i>
                  </div>
                  <span> investigation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-investigator"></i>
                  </div>
                  <span> investigator </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jail"></i>
                  </div>
                  <span> jail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-judge"></i>
                  </div>
                  <span> judge </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law-alt-1"></i>
                  </div>
                  <span> law-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law-alt-2"></i>
                  </div>
                  <span> law-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law-alt-3"></i>
                  </div>
                  <span> law-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law-book"></i>
                  </div>
                  <span> law-book </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law-document"></i>
                  </div>
                  <span> law-document </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law-order"></i>
                  </div>
                  <span> law-order </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law-protect"></i>
                  </div>
                  <span> law-protect </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law-scales"></i>
                  </div>
                  <span> law-scales </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-law"></i>
                  </div>
                  <span> law </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lawyer-alt-1"></i>
                  </div>
                  <span> lawyer-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lawyer-alt-2"></i>
                  </div>
                  <span> lawyer-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lawyer"></i>
                  </div>
                  <span> lawyer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-legal"></i>
                  </div>
                  <span> legal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pistol"></i>
                  </div>
                  <span> pistol </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-police-badge"></i>
                  </div>
                  <span> police-badge </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-police-cap"></i>
                  </div>
                  <span> police-cap </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-police-car-alt-1"></i>
                  </div>
                  <span> police-car-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-police-car-alt-2"></i>
                  </div>
                  <span> police-car-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-police-car"></i>
                  </div>
                  <span> police-car </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-police-hat"></i>
                  </div>
                  <span> police-hat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-police-van"></i>
                  </div>
                  <span> police-van </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-police"></i>
                  </div>
                  <span> police </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thief-alt"></i>
                  </div>
                  <span> thief-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thief"></i>
                  </div>
                  <span> thief </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-abacus-alt"></i>
                  </div>
                  <span> abacus-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-abacus"></i>
                  </div>
                  <span> abacus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-angle-180"></i>
                  </div>
                  <span> angle-180 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-angle-45"></i>
                  </div>
                  <span> angle-45 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-angle-90"></i>
                  </div>
                  <span> angle-90 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-angle"></i>
                  </div>
                  <span> angle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-calculator-alt-1"></i>
                  </div>
                  <span> calculator-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-calculator-alt-2"></i>
                  </div>
                  <span> calculator-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-calculator"></i>
                  </div>
                  <span> calculator </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-circle-ruler-alt"></i>
                  </div>
                  <span> circle-ruler-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-circle-ruler"></i>
                  </div>
                  <span> circle-ruler </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-compass-alt-1"></i>
                  </div>
                  <span> compass-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-compass-alt-2"></i>
                  </div>
                  <span> compass-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-compass-alt-3"></i>
                  </div>
                  <span> compass-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-compass-alt-4"></i>
                  </div>
                  <span> compass-alt-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-golden-ratio"></i>
                  </div>
                  <span> golden-ratio </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-marker-alt-1"></i>
                  </div>
                  <span> marker-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-marker-alt-2"></i>
                  </div>
                  <span> marker-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-marker-alt-3"></i>
                  </div>
                  <span> marker-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-marker"></i>
                  </div>
                  <span> marker </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-math"></i>
                  </div>
                  <span> math </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mathematical-alt-1"></i>
                  </div>
                  <span> mathematical-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mathematical-alt-2"></i>
                  </div>
                  <span> mathematical-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mathematical"></i>
                  </div>
                  <span> mathematical </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pen-alt-1"></i>
                  </div>
                  <span> pen-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pen-alt-2"></i>
                  </div>
                  <span> pen-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pen-alt-3"></i>
                  </div>
                  <span> pen-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pen-holder-alt-1"></i>
                  </div>
                  <span> pen-holder-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pen-holder"></i>
                  </div>
                  <span> pen-holder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pen"></i>
                  </div>
                  <span> pen </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pencil-alt-1"></i>
                  </div>
                  <span> pencil-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pencil-alt-2"></i>
                  </div>
                  <span> pencil-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pencil-alt-3"></i>
                  </div>
                  <span> pencil-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pencil-alt-4"></i>
                  </div>
                  <span> pencil-alt-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pencil"></i>
                  </div>
                  <span> pencil </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ruler-alt-1"></i>
                  </div>
                  <span> ruler-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ruler-alt-2"></i>
                  </div>
                  <span> ruler-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ruler-compass-alt"></i>
                  </div>
                  <span> ruler-compass-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ruler-compass"></i>
                  </div>
                  <span> ruler-compass </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ruler-pencil-alt-1"></i>
                  </div>
                  <span> ruler-pencil-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ruler-pencil-alt-2"></i>
                  </div>
                  <span> ruler-pencil-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ruler-pencil"></i>
                  </div>
                  <span> ruler-pencil </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ruler"></i>
                  </div>
                  <span> ruler </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rulers-alt"></i>
                  </div>
                  <span> rulers-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rulers"></i>
                  </div>
                  <span> rulers </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-square-root"></i>
                  </div>
                  <span> square-root </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-calculator"></i>
                  </div>
                  <span> ui-calculator </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-aids"></i>
                  </div>
                  <span> aids </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ambulance-crescent"></i>
                  </div>
                  <span> ambulance-crescent </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ambulance-cross"></i>
                  </div>
                  <span> ambulance-cross </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ambulance"></i>
                  </div>
                  <span> ambulance </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-autism"></i>
                  </div>
                  <span> autism </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bandage"></i>
                  </div>
                  <span> bandage </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-blind"></i>
                  </div>
                  <span> blind </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-blood-drop"></i>
                  </div>
                  <span> blood-drop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-blood-test"></i>
                  </div>
                  <span> blood-test </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-blood"></i>
                  </div>
                  <span> blood </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brain-alt"></i>
                  </div>
                  <span> brain-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brain"></i>
                  </div>
                  <span> brain </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-capsule"></i>
                  </div>
                  <span> capsule </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crutch"></i>
                  </div>
                  <span> crutch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-disabled"></i>
                  </div>
                  <span> disabled </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dna-alt-1"></i>
                  </div>
                  <span> dna-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dna-alt-2"></i>
                  </div>
                  <span> dna-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dna"></i>
                  </div>
                  <span> dna </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-doctor-alt"></i>
                  </div>
                  <span> doctor-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-doctor"></i>
                  </div>
                  <span> doctor </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-drug-pack"></i>
                  </div>
                  <span> drug-pack </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-drug"></i>
                  </div>
                  <span> drug </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-first-aid-alt"></i>
                  </div>
                  <span> first-aid-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-first-aid"></i>
                  </div>
                  <span> first-aid </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-heart-beat-alt"></i>
                  </div>
                  <span> heart-beat-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-heart-beat"></i>
                  </div>
                  <span> heart-beat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-heartbeat"></i>
                  </div>
                  <span> heartbeat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-herbal"></i>
                  </div>
                  <span> herbal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hospital"></i>
                  </div>
                  <span> hospital </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-icu"></i>
                  </div>
                  <span> icu </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-injection-syringe"></i>
                  </div>
                  <span> injection-syringe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-laboratory"></i>
                  </div>
                  <span> laboratory </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-medical-sign-alt"></i>
                  </div>
                  <span> medical-sign-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-medical-sign"></i>
                  </div>
                  <span> medical-sign </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-nurse-alt"></i>
                  </div>
                  <span> nurse-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-nurse"></i>
                  </div>
                  <span> nurse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-nursing-home"></i>
                  </div>
                  <span> nursing-home </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-operation-theater"></i>
                  </div>
                  <span> operation-theater </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paralysis-disability"></i>
                  </div>
                  <span> paralysis-disability </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-patient-bed"></i>
                  </div>
                  <span> patient-bed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-patient-file"></i>
                  </div>
                  <span> patient-file </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pills"></i>
                  </div>
                  <span> pills </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-prescription"></i>
                  </div>
                  <span> prescription </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pulse"></i>
                  </div>
                  <span> pulse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stethoscope-alt"></i>
                  </div>
                  <span> stethoscope-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stethoscope"></i>
                  </div>
                  <span> stethoscope </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stretcher"></i>
                  </div>
                  <span> stretcher </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-surgeon-alt"></i>
                  </div>
                  <span> surgeon-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-surgeon"></i>
                  </div>
                  <span> surgeon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tablets"></i>
                  </div>
                  <span> tablets </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-test-bottle"></i>
                  </div>
                  <span> test-bottle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-test-tube"></i>
                  </div>
                  <span> test-tube </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thermometer-alt"></i>
                  </div>
                  <span> thermometer-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thermometer"></i>
                  </div>
                  <span> thermometer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tooth"></i>
                  </div>
                  <span> tooth </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-xray"></i>
                  </div>
                  <span> xray </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-add"></i>
                  </div>
                  <span> ui-add </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-alarm"></i>
                  </div>
                  <span> ui-alarm </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-battery"></i>
                  </div>
                  <span> ui-battery </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-block"></i>
                  </div>
                  <span> ui-block </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-bluetooth"></i>
                  </div>
                  <span> ui-bluetooth </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-brightness"></i>
                  </div>
                  <span> ui-brightness </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-browser"></i>
                  </div>
                  <span> ui-browser </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-calendar"></i>
                  </div>
                  <span> ui-calendar </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-call"></i>
                  </div>
                  <span> ui-call </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-camera"></i>
                  </div>
                  <span> ui-camera </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-cart"></i>
                  </div>
                  <span> ui-cart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-cell-phone"></i>
                  </div>
                  <span> ui-cell-phone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-chat"></i>
                  </div>
                  <span> ui-chat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-check"></i>
                  </div>
                  <span> ui-check </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-clip-board"></i>
                  </div>
                  <span> ui-clip-board </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-clip"></i>
                  </div>
                  <span> ui-clip </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-clock"></i>
                  </div>
                  <span> ui-clock </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-close"></i>
                  </div>
                  <span> ui-close </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-contact-list"></i>
                  </div>
                  <span> ui-contact-list </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-copy"></i>
                  </div>
                  <span> ui-copy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-cut"></i>
                  </div>
                  <span> ui-cut </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-delete"></i>
                  </div>
                  <span> ui-delete </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-dial-phone"></i>
                  </div>
                  <span> ui-dial-phone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-edit"></i>
                  </div>
                  <span> ui-edit </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-email"></i>
                  </div>
                  <span> ui-email </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-file"></i>
                  </div>
                  <span> ui-file </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-fire-wall"></i>
                  </div>
                  <span> ui-fire-wall </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-flash-light"></i>
                  </div>
                  <span> ui-flash-light </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-flight"></i>
                  </div>
                  <span> ui-flight </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-folder"></i>
                  </div>
                  <span> ui-folder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-game"></i>
                  </div>
                  <span> ui-game </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-handicapped"></i>
                  </div>
                  <span> ui-handicapped </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-home"></i>
                  </div>
                  <span> ui-home </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-image"></i>
                  </div>
                  <span> ui-image </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-laoding"></i>
                  </div>
                  <span> ui-laoding </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-lock"></i>
                  </div>
                  <span> ui-lock </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-love-add"></i>
                  </div>
                  <span> ui-love-add </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-love-broken"></i>
                  </div>
                  <span> ui-love-broken </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-love-remove"></i>
                  </div>
                  <span> ui-love-remove </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-love"></i>
                  </div>
                  <span> ui-love </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-map"></i>
                  </div>
                  <span> ui-map </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-message"></i>
                  </div>
                  <span> ui-message </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-messaging"></i>
                  </div>
                  <span> ui-messaging </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-movie"></i>
                  </div>
                  <span> ui-movie </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-music-player"></i>
                  </div>
                  <span> ui-music-player </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-music"></i>
                  </div>
                  <span> ui-music </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-mute"></i>
                  </div>
                  <span> ui-mute </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-network"></i>
                  </div>
                  <span> ui-network </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-next"></i>
                  </div>
                  <span> ui-next </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-note"></i>
                  </div>
                  <span> ui-note </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-office"></i>
                  </div>
                  <span> ui-office </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-password"></i>
                  </div>
                  <span> ui-password </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-pause"></i>
                  </div>
                  <span> ui-pause </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-play-stop"></i>
                  </div>
                  <span> ui-play-stop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-play"></i>
                  </div>
                  <span> ui-play </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-pointer"></i>
                  </div>
                  <span> ui-pointer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-power"></i>
                  </div>
                  <span> ui-power </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-press"></i>
                  </div>
                  <span> ui-press </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-previous"></i>
                  </div>
                  <span> ui-previous </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-rate-add"></i>
                  </div>
                  <span> ui-rate-add </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-rate-blank"></i>
                  </div>
                  <span> ui-rate-blank </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-rate-remove"></i>
                  </div>
                  <span> ui-rate-remove </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-rating"></i>
                  </div>
                  <span> ui-rating </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-record"></i>
                  </div>
                  <span> ui-record </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-remove"></i>
                  </div>
                  <span> ui-remove </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-reply"></i>
                  </div>
                  <span> ui-reply </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-rotation"></i>
                  </div>
                  <span> ui-rotation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-rss"></i>
                  </div>
                  <span> ui-rss </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-search"></i>
                  </div>
                  <span> ui-search </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-settings"></i>
                  </div>
                  <span> ui-settings </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-social-link"></i>
                  </div>
                  <span> ui-social-link </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-tag"></i>
                  </div>
                  <span> ui-tag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-text-chat"></i>
                  </div>
                  <span> ui-text-chat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-text-loading"></i>
                  </div>
                  <span> ui-text-loading </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-theme"></i>
                  </div>
                  <span> ui-theme </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-timer"></i>
                  </div>
                  <span> ui-timer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-touch-phone"></i>
                  </div>
                  <span> ui-touch-phone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-travel"></i>
                  </div>
                  <span> ui-travel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-unlock"></i>
                  </div>
                  <span> ui-unlock </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-user-group"></i>
                  </div>
                  <span> ui-user-group </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-user"></i>
                  </div>
                  <span> ui-user </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-v-card"></i>
                  </div>
                  <span> ui-v-card </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-video-chat"></i>
                  </div>
                  <span> ui-video-chat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-video-message"></i>
                  </div>
                  <span> ui-video-message </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-video-play"></i>
                  </div>
                  <span> ui-video-play </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-video"></i>
                  </div>
                  <span> ui-video </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-volume"></i>
                  </div>
                  <span> ui-volume </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-weather"></i>
                  </div>
                  <span> ui-weather </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-wifi"></i>
                  </div>
                  <span> ui-wifi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-zoom-in"></i>
                  </div>
                  <span> ui-zoom-in </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ui-zoom-out"></i>
                  </div>
                  <span> ui-zoom-out </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cassette-player"></i>
                  </div>
                  <span> cassette-player </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cassette"></i>
                  </div>
                  <span> cassette </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-forward"></i>
                  </div>
                  <span> forward </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-guiter"></i>
                  </div>
                  <span> guiter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-movie"></i>
                  </div>
                  <span> movie </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-multimedia"></i>
                  </div>
                  <span> multimedia </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-music-alt"></i>
                  </div>
                  <span> music-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-music-disk"></i>
                  </div>
                  <span> music-disk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-music-note"></i>
                  </div>
                  <span> music-note </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-music-notes"></i>
                  </div>
                  <span> music-notes </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-music"></i>
                  </div>
                  <span> music </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mute-volume"></i>
                  </div>
                  <span> mute-volume </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pause"></i>
                  </div>
                  <span> pause </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-play-alt-1"></i>
                  </div>
                  <span> play-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-play-alt-2"></i>
                  </div>
                  <span> play-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-play-alt-3"></i>
                  </div>
                  <span> play-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-play-pause"></i>
                  </div>
                  <span> play-pause </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-play"></i>
                  </div>
                  <span> play </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-record"></i>
                  </div>
                  <span> record </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-retro-music-disk"></i>
                  </div>
                  <span> retro-music-disk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rewind"></i>
                  </div>
                  <span> rewind </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-song-notes"></i>
                  </div>
                  <span> song-notes </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sound-wave-alt"></i>
                  </div>
                  <span> sound-wave-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sound-wave"></i>
                  </div>
                  <span> sound-wave </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stop"></i>
                  </div>
                  <span> stop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-video-alt"></i>
                  </div>
                  <span> video-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-video-cam"></i>
                  </div>
                  <span> video-cam </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-video-clapper"></i>
                  </div>
                  <span> video-clapper </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-video"></i>
                  </div>
                  <span> video </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volume-bar"></i>
                  </div>
                  <span> volume-bar </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volume-down"></i>
                  </div>
                  <span> volume-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volume-mute"></i>
                  </div>
                  <span> volume-mute </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volume-off"></i>
                  </div>
                  <span> volume-off </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volume-up"></i>
                  </div>
                  <span> volume-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-youtube-play"></i>
                  </div>
                  <span> youtube-play </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-2checkout-alt"></i>
                  </div>
                  <span> 2checkout-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-2checkout"></i>
                  </div>
                  <span> 2checkout </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-amazon-alt"></i>
                  </div>
                  <span> amazon-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-amazon"></i>
                  </div>
                  <span> amazon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-american-express-alt"></i>
                  </div>
                  <span> american-express-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-american-express"></i>
                  </div>
                  <span> american-express </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-apple-pay-alt"></i>
                  </div>
                  <span> apple-pay-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-apple-pay"></i>
                  </div>
                  <span> apple-pay </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bank-transfer-alt"></i>
                  </div>
                  <span> bank-transfer-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bank-transfer"></i>
                  </div>
                  <span> bank-transfer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-braintree-alt"></i>
                  </div>
                  <span> braintree-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-braintree"></i>
                  </div>
                  <span> braintree </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cash-on-delivery-alt"></i>
                  </div>
                  <span> cash-on-delivery-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cash-on-delivery"></i>
                  </div>
                  <span> cash-on-delivery </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-diners-club-alt-1"></i>
                  </div>
                  <span> diners-club-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-diners-club-alt-2"></i>
                  </div>
                  <span> diners-club-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-diners-club-alt-3"></i>
                  </div>
                  <span> diners-club-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-diners-club"></i>
                  </div>
                  <span> diners-club </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-discover-alt"></i>
                  </div>
                  <span> discover-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-discover"></i>
                  </div>
                  <span> discover </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eway-alt"></i>
                  </div>
                  <span> eway-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eway"></i>
                  </div>
                  <span> eway </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-wallet-alt-1"></i>
                  </div>
                  <span> google-wallet-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-wallet-alt-2"></i>
                  </div>
                  <span> google-wallet-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-wallet-alt-3"></i>
                  </div>
                  <span> google-wallet-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-wallet"></i>
                  </div>
                  <span> google-wallet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jcb-alt"></i>
                  </div>
                  <span> jcb-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jcb"></i>
                  </div>
                  <span> jcb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-maestro-alt"></i>
                  </div>
                  <span> maestro-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-maestro"></i>
                  </div>
                  <span> maestro </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mastercard-alt"></i>
                  </div>
                  <span> mastercard-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mastercard"></i>
                  </div>
                  <span> mastercard </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-payoneer-alt"></i>
                  </div>
                  <span> payoneer-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-payoneer"></i>
                  </div>
                  <span> payoneer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paypal-alt"></i>
                  </div>
                  <span> paypal-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paypal"></i>
                  </div>
                  <span> paypal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sage-alt"></i>
                  </div>
                  <span> sage-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sage"></i>
                  </div>
                  <span> sage </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-skrill-alt"></i>
                  </div>
                  <span> skrill-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-skrill"></i>
                  </div>
                  <span> skrill </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stripe-alt"></i>
                  </div>
                  <span> stripe-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stripe"></i>
                  </div>
                  <span> stripe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-visa-alt"></i>
                  </div>
                  <span> visa-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-visa-electron"></i>
                  </div>
                  <span> visa-electron </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-visa"></i>
                  </div>
                  <span> visa </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-western-union-alt"></i>
                  </div>
                  <span> western-union-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-western-union"></i>
                  </div>
                  <span> western-union </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-boy"></i>
                  </div>
                  <span> boy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-business-man-alt-1"></i>
                  </div>
                  <span> business-man-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-business-man-alt-2"></i>
                  </div>
                  <span> business-man-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-business-man-alt-3"></i>
                  </div>
                  <span> business-man-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-business-man"></i>
                  </div>
                  <span> business-man </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-female"></i>
                  </div>
                  <span> female </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-funky-man"></i>
                  </div>
                  <span> funky-man </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-girl-alt"></i>
                  </div>
                  <span> girl-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-girl"></i>
                  </div>
                  <span> girl </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-group"></i>
                  </div>
                  <span> group </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hotel-boy-alt"></i>
                  </div>
                  <span> hotel-boy-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hotel-boy"></i>
                  </div>
                  <span> hotel-boy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kid"></i>
                  </div>
                  <span> kid </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-man-in-glasses"></i>
                  </div>
                  <span> man-in-glasses </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-people"></i>
                  </div>
                  <span> people </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-support"></i>
                  </div>
                  <span> support </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-alt-1"></i>
                  </div>
                  <span> user-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-alt-2"></i>
                  </div>
                  <span> user-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-alt-3"></i>
                  </div>
                  <span> user-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-alt-4"></i>
                  </div>
                  <span> user-alt-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-alt-5"></i>
                  </div>
                  <span> user-alt-5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-alt-6"></i>
                  </div>
                  <span> user-alt-6 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-alt-7"></i>
                  </div>
                  <span> user-alt-7 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-female"></i>
                  </div>
                  <span> user-female </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-male"></i>
                  </div>
                  <span> user-male </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user-suited"></i>
                  </div>
                  <span> user-suited </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-user"></i>
                  </div>
                  <span> user </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-users-alt-1"></i>
                  </div>
                  <span> users-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-users-alt-2"></i>
                  </div>
                  <span> users-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-users-alt-3"></i>
                  </div>
                  <span> users-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-users-alt-4"></i>
                  </div>
                  <span> users-alt-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-users-alt-5"></i>
                  </div>
                  <span> users-alt-5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-users-alt-6"></i>
                  </div>
                  <span> users-alt-6 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-users-social"></i>
                  </div>
                  <span> users-social </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-users"></i>
                  </div>
                  <span> users </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-waiter-alt"></i>
                  </div>
                  <span> waiter-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-waiter"></i>
                  </div>
                  <span> waiter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-woman-in-glasses"></i>
                  </div>
                  <span> woman-in-glasses </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-1"></i>
                  </div>
                  <span> search-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-2"></i>
                  </div>
                  <span> search-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-document"></i>
                  </div>
                  <span> search-document </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-folder"></i>
                  </div>
                  <span> search-folder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-job"></i>
                  </div>
                  <span> search-job </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-map"></i>
                  </div>
                  <span> search-map </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-property"></i>
                  </div>
                  <span> search-property </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-restaurant"></i>
                  </div>
                  <span> search-restaurant </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-stock"></i>
                  </div>
                  <span> search-stock </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search-user"></i>
                  </div>
                  <span> search-user </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-search"></i>
                  </div>
                  <span> search </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-500px"></i>
                  </div>
                  <span> 500px </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-aim"></i>
                  </div>
                  <span> aim </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-badoo"></i>
                  </div>
                  <span> badoo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baidu-tieba"></i>
                  </div>
                  <span> baidu-tieba </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bbm-messenger"></i>
                  </div>
                  <span> bbm-messenger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bebo"></i>
                  </div>
                  <span> bebo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-behance"></i>
                  </div>
                  <span> behance </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-blogger"></i>
                  </div>
                  <span> blogger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bootstrap"></i>
                  </div>
                  <span> bootstrap </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brightkite"></i>
                  </div>
                  <span> brightkite </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cloudapp"></i>
                  </div>
                  <span> cloudapp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-concrete5"></i>
                  </div>
                  <span> concrete5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-delicious"></i>
                  </div>
                  <span> delicious </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-designbump"></i>
                  </div>
                  <span> designbump </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-designfloat"></i>
                  </div>
                  <span> designfloat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-deviantart"></i>
                  </div>
                  <span> deviantart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-digg"></i>
                  </div>
                  <span> digg </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dotcms"></i>
                  </div>
                  <span> dotcms </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dribbble"></i>
                  </div>
                  <span> dribbble </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dribble"></i>
                  </div>
                  <span> dribble </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dropbox"></i>
                  </div>
                  <span> dropbox </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ebuddy"></i>
                  </div>
                  <span> ebuddy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ello"></i>
                  </div>
                  <span> ello </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ember"></i>
                  </div>
                  <span> ember </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-envato"></i>
                  </div>
                  <span> envato </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-evernote"></i>
                  </div>
                  <span> evernote </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-facebook-messenger"></i>
                  </div>
                  <span> facebook-messenger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-facebook"></i>
                  </div>
                  <span> facebook </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-feedburner"></i>
                  </div>
                  <span> feedburner </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flikr"></i>
                  </div>
                  <span> flikr </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-folkd"></i>
                  </div>
                  <span> folkd </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-foursquare"></i>
                  </div>
                  <span> foursquare </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-friendfeed"></i>
                  </div>
                  <span> friendfeed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ghost"></i>
                  </div>
                  <span> ghost </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-github"></i>
                  </div>
                  <span> github </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gnome"></i>
                  </div>
                  <span> gnome </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-buzz"></i>
                  </div>
                  <span> google-buzz </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-hangouts"></i>
                  </div>
                  <span> google-hangouts </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-map"></i>
                  </div>
                  <span> google-map </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-plus"></i>
                  </div>
                  <span> google-plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-google-talk"></i>
                  </div>
                  <span> google-talk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hype-machine"></i>
                  </div>
                  <span> hype-machine </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-instagram"></i>
                  </div>
                  <span> instagram </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kakaotalk"></i>
                  </div>
                  <span> kakaotalk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kickstarter"></i>
                  </div>
                  <span> kickstarter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kik"></i>
                  </div>
                  <span> kik </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kiwibox"></i>
                  </div>
                  <span> kiwibox </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-line-messenger"></i>
                  </div>
                  <span> line-messenger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-line"></i>
                  </div>
                  <span> line </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-linkedin"></i>
                  </div>
                  <span> linkedin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-linux-mint"></i>
                  </div>
                  <span> linux-mint </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-live-messenger"></i>
                  </div>
                  <span> live-messenger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-livejournal"></i>
                  </div>
                  <span> livejournal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-magento"></i>
                  </div>
                  <span> magento </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-meetme"></i>
                  </div>
                  <span> meetme </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-meetup"></i>
                  </div>
                  <span> meetup </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mixx"></i>
                  </div>
                  <span> mixx </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-newsvine"></i>
                  </div>
                  <span> newsvine </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-nimbuss"></i>
                  </div>
                  <span> nimbuss </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-odnoklassniki"></i>
                  </div>
                  <span> odnoklassniki </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-opencart"></i>
                  </div>
                  <span> opencart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-oscommerce"></i>
                  </div>
                  <span> oscommerce </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pandora"></i>
                  </div>
                  <span> pandora </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-photobucket"></i>
                  </div>
                  <span> photobucket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-picasa"></i>
                  </div>
                  <span> picasa </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pinterest"></i>
                  </div>
                  <span> pinterest </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-prestashop"></i>
                  </div>
                  <span> prestashop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-qik"></i>
                  </div>
                  <span> qik </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-qq"></i>
                  </div>
                  <span> qq </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-readernaut"></i>
                  </div>
                  <span> readernaut </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-reddit"></i>
                  </div>
                  <span> reddit </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-renren"></i>
                  </div>
                  <span> renren </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rss"></i>
                  </div>
                  <span> rss </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-shopify"></i>
                  </div>
                  <span> shopify </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-silverstripe"></i>
                  </div>
                  <span> silverstripe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-skype"></i>
                  </div>
                  <span> skype </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-slack"></i>
                  </div>
                  <span> slack </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-slashdot"></i>
                  </div>
                  <span> slashdot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-slidshare"></i>
                  </div>
                  <span> slidshare </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-smugmug"></i>
                  </div>
                  <span> smugmug </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snapchat"></i>
                  </div>
                  <span> snapchat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-soundcloud"></i>
                  </div>
                  <span> soundcloud </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spotify"></i>
                  </div>
                  <span> spotify </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stack-exchange"></i>
                  </div>
                  <span> stack-exchange </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stack-overflow"></i>
                  </div>
                  <span> stack-overflow </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-steam"></i>
                  </div>
                  <span> steam </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stumbleupon"></i>
                  </div>
                  <span> stumbleupon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tagged"></i>
                  </div>
                  <span> tagged </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-technorati"></i>
                  </div>
                  <span> technorati </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-telegram"></i>
                  </div>
                  <span> telegram </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tinder"></i>
                  </div>
                  <span> tinder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-trello"></i>
                  </div>
                  <span> trello </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tumblr"></i>
                  </div>
                  <span> tumblr </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-twitch"></i>
                  </div>
                  <span> twitch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-twitter"></i>
                  </div>
                  <span> twitter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-typo3"></i>
                  </div>
                  <span> typo3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ubercart"></i>
                  </div>
                  <span> ubercart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-viber"></i>
                  </div>
                  <span> viber </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-viddler"></i>
                  </div>
                  <span> viddler </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vimeo"></i>
                  </div>
                  <span> vimeo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vine"></i>
                  </div>
                  <span> vine </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-virb"></i>
                  </div>
                  <span> virb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-virtuemart"></i>
                  </div>
                  <span> virtuemart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vk"></i>
                  </div>
                  <span> vk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wechat"></i>
                  </div>
                  <span> wechat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-weibo"></i>
                  </div>
                  <span> weibo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-whatsapp"></i>
                  </div>
                  <span> whatsapp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-xing"></i>
                  </div>
                  <span> xing </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-yahoo"></i>
                  </div>
                  <span> yahoo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-yelp"></i>
                  </div>
                  <span> yelp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-youku"></i>
                  </div>
                  <span> youku </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-youtube"></i>
                  </div>
                  <span> youtube </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-zencart"></i>
                  </div>
                  <span> zencart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-badminton-birdie"></i>
                  </div>
                  <span> badminton-birdie </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baseball"></i>
                  </div>
                  <span> baseball </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-baseballer"></i>
                  </div>
                  <span> baseballer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-basketball-hoop"></i>
                  </div>
                  <span> basketball-hoop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-basketball"></i>
                  </div>
                  <span> basketball </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-billiard-ball"></i>
                  </div>
                  <span> billiard-ball </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-boot-alt-1"></i>
                  </div>
                  <span> boot-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-boot-alt-2"></i>
                  </div>
                  <span> boot-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-boot"></i>
                  </div>
                  <span> boot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bowling-alt"></i>
                  </div>
                  <span> bowling-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bowling"></i>
                  </div>
                  <span> bowling </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-canoe"></i>
                  </div>
                  <span> canoe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cheer-leader"></i>
                  </div>
                  <span> cheer-leader </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-climbing"></i>
                  </div>
                  <span> climbing </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-corner"></i>
                  </div>
                  <span> corner </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-field-alt"></i>
                  </div>
                  <span> field-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-field"></i>
                  </div>
                  <span> field </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-football-alt"></i>
                  </div>
                  <span> football-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-football-american"></i>
                  </div>
                  <span> football-american </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-football"></i>
                  </div>
                  <span> football </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-foul"></i>
                  </div>
                  <span> foul </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-goal-keeper"></i>
                  </div>
                  <span> goal-keeper </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-goal"></i>
                  </div>
                  <span> goal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-golf-alt"></i>
                  </div>
                  <span> golf-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-golf-bag"></i>
                  </div>
                  <span> golf-bag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-golf-cart"></i>
                  </div>
                  <span> golf-cart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-golf-field"></i>
                  </div>
                  <span> golf-field </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-golf"></i>
                  </div>
                  <span> golf </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-golfer"></i>
                  </div>
                  <span> golfer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-helmet"></i>
                  </div>
                  <span> helmet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hockey-alt"></i>
                  </div>
                  <span> hockey-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hockey"></i>
                  </div>
                  <span> hockey </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ice-skate"></i>
                  </div>
                  <span> ice-skate </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jersey-alt"></i>
                  </div>
                  <span> jersey-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jersey"></i>
                  </div>
                  <span> jersey </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jumping"></i>
                  </div>
                  <span> jumping </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-kick"></i>
                  </div>
                  <span> kick </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-leg"></i>
                  </div>
                  <span> leg </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-match-review"></i>
                  </div>
                  <span> match-review </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-medal-sport"></i>
                  </div>
                  <span> medal-sport </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-offside"></i>
                  </div>
                  <span> offside </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-olympic-logo"></i>
                  </div>
                  <span> olympic-logo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-olympic"></i>
                  </div>
                  <span> olympic </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-padding"></i>
                  </div>
                  <span> padding </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-penalty-card"></i>
                  </div>
                  <span> penalty-card </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-racer"></i>
                  </div>
                  <span> racer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-racing-car"></i>
                  </div>
                  <span> racing-car </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-racing-flag-alt"></i>
                  </div>
                  <span> racing-flag-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-racing-flag"></i>
                  </div>
                  <span> racing-flag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-racings-wheel"></i>
                  </div>
                  <span> racings-wheel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-referee"></i>
                  </div>
                  <span> referee </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-refree-jersey"></i>
                  </div>
                  <span> refree-jersey </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-result-sport"></i>
                  </div>
                  <span> result-sport </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rugby-ball"></i>
                  </div>
                  <span> rugby-ball </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rugby-player"></i>
                  </div>
                  <span> rugby-player </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rugby"></i>
                  </div>
                  <span> rugby </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-runner-alt-1"></i>
                  </div>
                  <span> runner-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-runner-alt-2"></i>
                  </div>
                  <span> runner-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-runner"></i>
                  </div>
                  <span> runner </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-score-board"></i>
                  </div>
                  <span> score-board </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-skiing-man"></i>
                  </div>
                  <span> skiing-man </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-skydiving-goggles"></i>
                  </div>
                  <span> skydiving-goggles </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snow-mobile"></i>
                  </div>
                  <span> snow-mobile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-steering"></i>
                  </div>
                  <span> steering </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-stopwatch"></i>
                  </div>
                  <span> stopwatch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-substitute"></i>
                  </div>
                  <span> substitute </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-swimmer"></i>
                  </div>
                  <span> swimmer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-table-tennis"></i>
                  </div>
                  <span> table-tennis </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-team-alt"></i>
                  </div>
                  <span> team-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-team"></i>
                  </div>
                  <span> team </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tennis-player"></i>
                  </div>
                  <span> tennis-player </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tennis"></i>
                  </div>
                  <span> tennis </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tracking"></i>
                  </div>
                  <span> tracking </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-trophy-alt"></i>
                  </div>
                  <span> trophy-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-trophy"></i>
                  </div>
                  <span> trophy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volleyball-alt"></i>
                  </div>
                  <span> volleyball-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volleyball-fire"></i>
                  </div>
                  <span> volleyball-fire </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volleyball"></i>
                  </div>
                  <span> volleyball </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-water-bottle"></i>
                  </div>
                  <span> water-bottle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-whistle-alt"></i>
                  </div>
                  <span> whistle-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-whistle"></i>
                  </div>
                  <span> whistle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-win-trophy"></i>
                  </div>
                  <span> win-trophy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-align-center"></i>
                  </div>
                  <span> align-center </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-align-left"></i>
                  </div>
                  <span> align-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-align-right"></i>
                  </div>
                  <span> align-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-all-caps"></i>
                  </div>
                  <span> all-caps </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bold"></i>
                  </div>
                  <span> bold </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-brush"></i>
                  </div>
                  <span> brush </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-clip-board"></i>
                  </div>
                  <span> clip-board </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-code-alt"></i>
                  </div>
                  <span> code-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-color-bucket"></i>
                  </div>
                  <span> color-bucket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-color-picker"></i>
                  </div>
                  <span> color-picker </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-copy-invert"></i>
                  </div>
                  <span> copy-invert </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-copy"></i>
                  </div>
                  <span> copy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cut"></i>
                  </div>
                  <span> cut </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-delete-alt"></i>
                  </div>
                  <span> delete-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-edit-alt"></i>
                  </div>
                  <span> edit-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eraser-alt"></i>
                  </div>
                  <span> eraser-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-font"></i>
                  </div>
                  <span> font </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-heading"></i>
                  </div>
                  <span> heading </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-indent"></i>
                  </div>
                  <span> indent </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-italic-alt"></i>
                  </div>
                  <span> italic-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-italic"></i>
                  </div>
                  <span> italic </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-justify-all"></i>
                  </div>
                  <span> justify-all </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-justify-center"></i>
                  </div>
                  <span> justify-center </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-justify-left"></i>
                  </div>
                  <span> justify-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-justify-right"></i>
                  </div>
                  <span> justify-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-link-broken"></i>
                  </div>
                  <span> link-broken </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-outdent"></i>
                  </div>
                  <span> outdent </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paper-clip"></i>
                  </div>
                  <span> paper-clip </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paragraph"></i>
                  </div>
                  <span> paragraph </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pin"></i>
                  </div>
                  <span> pin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-printer"></i>
                  </div>
                  <span> printer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-redo"></i>
                  </div>
                  <span> redo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rotation"></i>
                  </div>
                  <span> rotation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-save"></i>
                  </div>
                  <span> save </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-small-cap"></i>
                  </div>
                  <span> small-cap </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-strike-through"></i>
                  </div>
                  <span> strike-through </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sub-listing"></i>
                  </div>
                  <span> sub-listing </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-subscript"></i>
                  </div>
                  <span> subscript </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-superscript"></i>
                  </div>
                  <span> superscript </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-table"></i>
                  </div>
                  <span> table </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-text-height"></i>
                  </div>
                  <span> text-height </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-text-width"></i>
                  </div>
                  <span> text-width </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-trash"></i>
                  </div>
                  <span> trash </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-underline"></i>
                  </div>
                  <span> underline </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-undo"></i>
                  </div>
                  <span> undo </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-air-balloon"></i>
                  </div>
                  <span> air-balloon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-airplane-alt"></i>
                  </div>
                  <span> airplane-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-airplane"></i>
                  </div>
                  <span> airplane </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-articulated-truck"></i>
                  </div>
                  <span> articulated-truck </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-auto-mobile"></i>
                  </div>
                  <span> auto-mobile </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-auto-rickshaw"></i>
                  </div>
                  <span> auto-rickshaw </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bicycle-alt-1"></i>
                  </div>
                  <span> bicycle-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bicycle-alt-2"></i>
                  </div>
                  <span> bicycle-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bicycle"></i>
                  </div>
                  <span> bicycle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bus-alt-1"></i>
                  </div>
                  <span> bus-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bus-alt-2"></i>
                  </div>
                  <span> bus-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bus-alt-3"></i>
                  </div>
                  <span> bus-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bus"></i>
                  </div>
                  <span> bus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cab"></i>
                  </div>
                  <span> cab </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cable-car"></i>
                  </div>
                  <span> cable-car </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-car-alt-1"></i>
                  </div>
                  <span> car-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-car-alt-2"></i>
                  </div>
                  <span> car-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-car-alt-3"></i>
                  </div>
                  <span> car-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-car-alt-4"></i>
                  </div>
                  <span> car-alt-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-car"></i>
                  </div>
                  <span> car </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-delivery-time"></i>
                  </div>
                  <span> delivery-time </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fast-delivery"></i>
                  </div>
                  <span> fast-delivery </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fire-truck-alt"></i>
                  </div>
                  <span> fire-truck-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fire-truck"></i>
                  </div>
                  <span> fire-truck </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-free-delivery"></i>
                  </div>
                  <span> free-delivery </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-helicopter"></i>
                  </div>
                  <span> helicopter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-motor-bike-alt"></i>
                  </div>
                  <span> motor-bike-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-motor-bike"></i>
                  </div>
                  <span> motor-bike </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-motor-biker"></i>
                  </div>
                  <span> motor-biker </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-oil-truck"></i>
                  </div>
                  <span> oil-truck </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rickshaw"></i>
                  </div>
                  <span> rickshaw </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rocket-alt-1"></i>
                  </div>
                  <span> rocket-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rocket-alt-2"></i>
                  </div>
                  <span> rocket-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rocket"></i>
                  </div>
                  <span> rocket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sail-boat-alt-1"></i>
                  </div>
                  <span> sail-boat-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sail-boat-alt-2"></i>
                  </div>
                  <span> sail-boat-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sail-boat"></i>
                  </div>
                  <span> sail-boat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-scooter"></i>
                  </div>
                  <span> scooter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sea-plane"></i>
                  </div>
                  <span> sea-plane </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ship-alt"></i>
                  </div>
                  <span> ship-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ship"></i>
                  </div>
                  <span> ship </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-speed-boat"></i>
                  </div>
                  <span> speed-boat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-taxi"></i>
                  </div>
                  <span> taxi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tractor"></i>
                  </div>
                  <span> tractor </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-train-line"></i>
                  </div>
                  <span> train-line </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-train-steam"></i>
                  </div>
                  <span> train-steam </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tram"></i>
                  </div>
                  <span> tram </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-truck-alt"></i>
                  </div>
                  <span> truck-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-truck-loaded"></i>
                  </div>
                  <span> truck-loaded </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-truck"></i>
                  </div>
                  <span> truck </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-van-alt"></i>
                  </div>
                  <span> van-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-van"></i>
                  </div>
                  <span> van </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-yacht"></i>
                  </div>
                  <span> yacht </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-5-star-hotel"></i>
                  </div>
                  <span> 5-star-hotel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-air-ticket"></i>
                  </div>
                  <span> air-ticket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-beach-bed"></i>
                  </div>
                  <span> beach-bed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-beach"></i>
                  </div>
                  <span> beach </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-camping-vest"></i>
                  </div>
                  <span> camping-vest </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-direction-sign"></i>
                  </div>
                  <span> direction-sign </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hill-side"></i>
                  </div>
                  <span> hill-side </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hill"></i>
                  </div>
                  <span> hill </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hotel"></i>
                  </div>
                  <span> hotel </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-island-alt"></i>
                  </div>
                  <span> island-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-island"></i>
                  </div>
                  <span> island </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sandals-female"></i>
                  </div>
                  <span> sandals-female </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sandals-male"></i>
                  </div>
                  <span> sandals-male </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-travelling"></i>
                  </div>
                  <span> travelling </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-breakdown"></i>
                  </div>
                  <span> breakdown </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-celsius"></i>
                  </div>
                  <span> celsius </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-clouds"></i>
                  </div>
                  <span> clouds </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cloudy"></i>
                  </div>
                  <span> cloudy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dust"></i>
                  </div>
                  <span> dust </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eclipse"></i>
                  </div>
                  <span> eclipse </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fahrenheit"></i>
                  </div>
                  <span> fahrenheit </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-forest-fire"></i>
                  </div>
                  <span> forest-fire </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-full-night"></i>
                  </div>
                  <span> full-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-full-sunny"></i>
                  </div>
                  <span> full-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail-night"></i>
                  </div>
                  <span> hail-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail-rainy-night"></i>
                  </div>
                  <span> hail-rainy-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail-rainy-sunny"></i>
                  </div>
                  <span> hail-rainy-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail-rainy"></i>
                  </div>
                  <span> hail-rainy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail-sunny"></i>
                  </div>
                  <span> hail-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail-thunder-night"></i>
                  </div>
                  <span> hail-thunder-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail-thunder-sunny"></i>
                  </div>
                  <span> hail-thunder-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail-thunder"></i>
                  </div>
                  <span> hail-thunder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hail"></i>
                  </div>
                  <span> hail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hill-night"></i>
                  </div>
                  <span> hill-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hill-sunny"></i>
                  </div>
                  <span> hill-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hurricane"></i>
                  </div>
                  <span> hurricane </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-meteor"></i>
                  </div>
                  <span> meteor </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-night"></i>
                  </div>
                  <span> night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rainy-night"></i>
                  </div>
                  <span> rainy-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rainy-sunny"></i>
                  </div>
                  <span> rainy-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rainy-thunder"></i>
                  </div>
                  <span> rainy-thunder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rainy"></i>
                  </div>
                  <span> rainy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snow-alt"></i>
                  </div>
                  <span> snow-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snow-flake"></i>
                  </div>
                  <span> snow-flake </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snow-temp"></i>
                  </div>
                  <span> snow-temp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snow"></i>
                  </div>
                  <span> snow </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-hail"></i>
                  </div>
                  <span> snowy-hail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-night-hail"></i>
                  </div>
                  <span> snowy-night-hail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-night-rainy"></i>
                  </div>
                  <span> snowy-night-rainy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-night"></i>
                  </div>
                  <span> snowy-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-rainy"></i>
                  </div>
                  <span> snowy-rainy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-sunny-hail"></i>
                  </div>
                  <span> snowy-sunny-hail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-sunny-rainy"></i>
                  </div>
                  <span> snowy-sunny-rainy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-sunny"></i>
                  </div>
                  <span> snowy-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-thunder-night"></i>
                  </div>
                  <span> snowy-thunder-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-thunder-sunny"></i>
                  </div>
                  <span> snowy-thunder-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-thunder"></i>
                  </div>
                  <span> snowy-thunder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-windy-night"></i>
                  </div>
                  <span> snowy-windy-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-windy-sunny"></i>
                  </div>
                  <span> snowy-windy-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy-windy"></i>
                  </div>
                  <span> snowy-windy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-snowy"></i>
                  </div>
                  <span> snowy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sun-alt"></i>
                  </div>
                  <span> sun-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sun-rise"></i>
                  </div>
                  <span> sun-rise </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sun-set"></i>
                  </div>
                  <span> sun-set </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sun"></i>
                  </div>
                  <span> sun </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sunny-day-temp"></i>
                  </div>
                  <span> sunny-day-temp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sunny"></i>
                  </div>
                  <span> sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thunder-light"></i>
                  </div>
                  <span> thunder-light </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tornado"></i>
                  </div>
                  <span> tornado </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-umbrella-alt"></i>
                  </div>
                  <span> umbrella-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-umbrella"></i>
                  </div>
                  <span> umbrella </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-volcano"></i>
                  </div>
                  <span> volcano </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wave"></i>
                  </div>
                  <span> wave </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-0"></i>
                  </div>
                  <span> wind-scale-0 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-1"></i>
                  </div>
                  <span> wind-scale-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-10"></i>
                  </div>
                  <span> wind-scale-10 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-11"></i>
                  </div>
                  <span> wind-scale-11 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-12"></i>
                  </div>
                  <span> wind-scale-12 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-2"></i>
                  </div>
                  <span> wind-scale-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-3"></i>
                  </div>
                  <span> wind-scale-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-4"></i>
                  </div>
                  <span> wind-scale-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-5"></i>
                  </div>
                  <span> wind-scale-5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-6"></i>
                  </div>
                  <span> wind-scale-6 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-7"></i>
                  </div>
                  <span> wind-scale-7 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-8"></i>
                  </div>
                  <span> wind-scale-8 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-scale-9"></i>
                  </div>
                  <span> wind-scale-9 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind-waves"></i>
                  </div>
                  <span> wind-waves </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wind"></i>
                  </div>
                  <span> wind </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-windy-hail"></i>
                  </div>
                  <span> windy-hail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-windy-night"></i>
                  </div>
                  <span> windy-night </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-windy-raining"></i>
                  </div>
                  <span> windy-raining </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-windy-sunny"></i>
                  </div>
                  <span> windy-sunny </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-windy-thunder-raining"></i>
                  </div>
                  <span> windy-thunder-raining </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-windy-thunder"></i>
                  </div>
                  <span> windy-thunder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-windy"></i>
                  </div>
                  <span> windy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-addons"></i>
                  </div>
                  <span> addons </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-address-book"></i>
                  </div>
                  <span> address-book </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-adjust"></i>
                  </div>
                  <span> adjust </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-alarm"></i>
                  </div>
                  <span> alarm </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-anchor"></i>
                  </div>
                  <span> anchor </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-archive"></i>
                  </div>
                  <span> archive </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-at"></i>
                  </div>
                  <span> at </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-attachment"></i>
                  </div>
                  <span> attachment </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-audio"></i>
                  </div>
                  <span> audio </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-automation"></i>
                  </div>
                  <span> automation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-badge"></i>
                  </div>
                  <span> badge </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bag-alt"></i>
                  </div>
                  <span> bag-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bag"></i>
                  </div>
                  <span> bag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ban"></i>
                  </div>
                  <span> ban </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bar-code"></i>
                  </div>
                  <span> bar-code </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bars"></i>
                  </div>
                  <span> bars </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-basket"></i>
                  </div>
                  <span> basket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-battery-empty"></i>
                  </div>
                  <span> battery-empty </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-battery-full"></i>
                  </div>
                  <span> battery-full </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-battery-half"></i>
                  </div>
                  <span> battery-half </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-battery-low"></i>
                  </div>
                  <span> battery-low </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-beaker"></i>
                  </div>
                  <span> beaker </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-beard"></i>
                  </div>
                  <span> beard </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bed"></i>
                  </div>
                  <span> bed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bell"></i>
                  </div>
                  <span> bell </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-beverage"></i>
                  </div>
                  <span> beverage </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bill"></i>
                  </div>
                  <span> bill </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bin"></i>
                  </div>
                  <span> bin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-binary"></i>
                  </div>
                  <span> binary </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-binoculars"></i>
                  </div>
                  <span> binoculars </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bluetooth"></i>
                  </div>
                  <span> bluetooth </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bomb"></i>
                  </div>
                  <span> bomb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-book-mark"></i>
                  </div>
                  <span> book-mark </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-box"></i>
                  </div>
                  <span> box </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-briefcase"></i>
                  </div>
                  <span> briefcase </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-broken"></i>
                  </div>
                  <span> broken </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bucket"></i>
                  </div>
                  <span> bucket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bucket1"></i>
                  </div>
                  <span> bucket1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bucket2"></i>
                  </div>
                  <span> bucket2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bug"></i>
                  </div>
                  <span> bug </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-building"></i>
                  </div>
                  <span> building </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bulb-alt"></i>
                  </div>
                  <span> bulb-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bullet"></i>
                  </div>
                  <span> bullet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bullhorn"></i>
                  </div>
                  <span> bullhorn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-bullseye"></i>
                  </div>
                  <span> bullseye </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-calendar"></i>
                  </div>
                  <span> calendar </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-camera-alt"></i>
                  </div>
                  <span> camera-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-camera"></i>
                  </div>
                  <span> camera </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-card"></i>
                  </div>
                  <span> card </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cart-alt"></i>
                  </div>
                  <span> cart-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cart"></i>
                  </div>
                  <span> cart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cc"></i>
                  </div>
                  <span> cc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-charging"></i>
                  </div>
                  <span> charging </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-chat"></i>
                  </div>
                  <span> chat </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-check-alt"></i>
                  </div>
                  <span> check-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-check-circled"></i>
                  </div>
                  <span> check-circled </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-check"></i>
                  </div>
                  <span> check </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-checked"></i>
                  </div>
                  <span> checked </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-children-care"></i>
                  </div>
                  <span> children-care </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-clip"></i>
                  </div>
                  <span> clip </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-clock-time"></i>
                  </div>
                  <span> clock-time </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-close-circled"></i>
                  </div>
                  <span> close-circled </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-close-line-circled"></i>
                  </div>
                  <span> close-line-circled </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-close-line-squared-alt"></i>
                  </div>
                  <span> close-line-squared-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-close-line-squared"></i>
                  </div>
                  <span> close-line-squared </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-close-line"></i>
                  </div>
                  <span> close-line </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-close-squared-alt"></i>
                  </div>
                  <span> close-squared-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-close-squared"></i>
                  </div>
                  <span> close-squared </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-close"></i>
                  </div>
                  <span> close </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cloud-download"></i>
                  </div>
                  <span> cloud-download </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cloud-refresh"></i>
                  </div>
                  <span> cloud-refresh </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cloud-upload"></i>
                  </div>
                  <span> cloud-upload </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cloud"></i>
                  </div>
                  <span> cloud </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-code-not-allowed"></i>
                  </div>
                  <span> code-not-allowed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-code"></i>
                  </div>
                  <span> code </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-comment"></i>
                  </div>
                  <span> comment </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-compass-alt"></i>
                  </div>
                  <span> compass-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-compass"></i>
                  </div>
                  <span> compass </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-computer"></i>
                  </div>
                  <span> computer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-connection"></i>
                  </div>
                  <span> connection </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-console"></i>
                  </div>
                  <span> console </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-contacts"></i>
                  </div>
                  <span> contacts </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-contrast"></i>
                  </div>
                  <span> contrast </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-copyright"></i>
                  </div>
                  <span> copyright </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-credit-card"></i>
                  </div>
                  <span> credit-card </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crop"></i>
                  </div>
                  <span> crop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-crown"></i>
                  </div>
                  <span> crown </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cube"></i>
                  </div>
                  <span> cube </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-cubes"></i>
                  </div>
                  <span> cubes </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dashboard-web"></i>
                  </div>
                  <span> dashboard-web </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dashboard"></i>
                  </div>
                  <span> dashboard </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-data"></i>
                  </div>
                  <span> data </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-database-add"></i>
                  </div>
                  <span> database-add </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-database-locked"></i>
                  </div>
                  <span> database-locked </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-database-remove"></i>
                  </div>
                  <span> database-remove </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-database"></i>
                  </div>
                  <span> database </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-delete"></i>
                  </div>
                  <span> delete </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-diamond"></i>
                  </div>
                  <span> diamond </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dice-multiple"></i>
                  </div>
                  <span> dice-multiple </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-dice"></i>
                  </div>
                  <span> dice </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-disc"></i>
                  </div>
                  <span> disc </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-diskette"></i>
                  </div>
                  <span> diskette </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-document-folder"></i>
                  </div>
                  <span> document-folder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-download-alt"></i>
                  </div>
                  <span> download-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-download"></i>
                  </div>
                  <span> download </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-downloaded"></i>
                  </div>
                  <span> downloaded </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-drag"></i>
                  </div>
                  <span> drag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-drag1"></i>
                  </div>
                  <span> drag1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-drag2"></i>
                  </div>
                  <span> drag2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-drag3"></i>
                  </div>
                  <span> drag3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-earth"></i>
                  </div>
                  <span> earth </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ebook"></i>
                  </div>
                  <span> ebook </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-edit"></i>
                  </div>
                  <span> edit </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eject"></i>
                  </div>
                  <span> eject </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-email"></i>
                  </div>
                  <span> email </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-envelope-open"></i>
                  </div>
                  <span> envelope-open </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-envelope"></i>
                  </div>
                  <span> envelope </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eraser"></i>
                  </div>
                  <span> eraser </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-error"></i>
                  </div>
                  <span> error </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-excavator"></i>
                  </div>
                  <span> excavator </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-exchange"></i>
                  </div>
                  <span> exchange </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-exclamation-circle"></i>
                  </div>
                  <span> exclamation-circle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-exclamation-square"></i>
                  </div>
                  <span> exclamation-square </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-exclamation-tringle"></i>
                  </div>
                  <span> exclamation-tringle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-exclamation"></i>
                  </div>
                  <span> exclamation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-exit"></i>
                  </div>
                  <span> exit </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-expand"></i>
                  </div>
                  <span> expand </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-external-link"></i>
                  </div>
                  <span> external-link </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-external"></i>
                  </div>
                  <span> external </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eye-alt"></i>
                  </div>
                  <span> eye-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eye-blocked"></i>
                  </div>
                  <span> eye-blocked </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eye-dropper"></i>
                  </div>
                  <span> eye-dropper </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-eye"></i>
                  </div>
                  <span> eye </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-favourite"></i>
                  </div>
                  <span> favourite </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fax"></i>
                  </div>
                  <span> fax </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-file-fill"></i>
                  </div>
                  <span> file-fill </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-film"></i>
                  </div>
                  <span> film </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-filter"></i>
                  </div>
                  <span> filter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fire-alt"></i>
                  </div>
                  <span> fire-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fire-burn"></i>
                  </div>
                  <span> fire-burn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-fire"></i>
                  </div>
                  <span> fire </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flag-alt-1"></i>
                  </div>
                  <span> flag-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flag-alt-2"></i>
                  </div>
                  <span> flag-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flag"></i>
                  </div>
                  <span> flag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flame-torch"></i>
                  </div>
                  <span> flame-torch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flash-light"></i>
                  </div>
                  <span> flash-light </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flash"></i>
                  </div>
                  <span> flash </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-flask"></i>
                  </div>
                  <span> flask </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-focus"></i>
                  </div>
                  <span> focus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-folder-open"></i>
                  </div>
                  <span> folder-open </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-folder"></i>
                  </div>
                  <span> folder </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-foot-print"></i>
                  </div>
                  <span> foot-print </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-garbage"></i>
                  </div>
                  <span> garbage </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gear-alt"></i>
                  </div>
                  <span> gear-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gear"></i>
                  </div>
                  <span> gear </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gears"></i>
                  </div>
                  <span> gears </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-gift"></i>
                  </div>
                  <span> gift </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-glass"></i>
                  </div>
                  <span> glass </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-globe"></i>
                  </div>
                  <span> globe </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-graffiti"></i>
                  </div>
                  <span> graffiti </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-grocery"></i>
                  </div>
                  <span> grocery </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hand"></i>
                  </div>
                  <span> hand </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hanger"></i>
                  </div>
                  <span> hanger </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hard-disk"></i>
                  </div>
                  <span> hard-disk </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-heart-alt"></i>
                  </div>
                  <span> heart-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-heart"></i>
                  </div>
                  <span> heart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-history"></i>
                  </div>
                  <span> history </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-home"></i>
                  </div>
                  <span> home </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-horn"></i>
                  </div>
                  <span> horn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-hour-glass"></i>
                  </div>
                  <span> hour-glass </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-id"></i>
                  </div>
                  <span> id </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-image"></i>
                  </div>
                  <span> image </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-inbox"></i>
                  </div>
                  <span> inbox </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-infinite"></i>
                  </div>
                  <span> infinite </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-info-circle"></i>
                  </div>
                  <span> info-circle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-info-square"></i>
                  </div>
                  <span> info-square </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-info"></i>
                  </div>
                  <span> info </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-institution"></i>
                  </div>
                  <span> institution </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-interface"></i>
                  </div>
                  <span> interface </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-invisible"></i>
                  </div>
                  <span> invisible </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jacket"></i>
                  </div>
                  <span> jacket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jar"></i>
                  </div>
                  <span> jar </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-jewlery"></i>
                  </div>
                  <span> jewlery </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-karate"></i>
                  </div>
                  <span> karate </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-key-hole"></i>
                  </div>
                  <span> key-hole </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-key"></i>
                  </div>
                  <span> key </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-label"></i>
                  </div>
                  <span> label </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lamp"></i>
                  </div>
                  <span> lamp </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-layers"></i>
                  </div>
                  <span> layers </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-layout"></i>
                  </div>
                  <span> layout </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-leaf"></i>
                  </div>
                  <span> leaf </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-leaflet"></i>
                  </div>
                  <span> leaflet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-learn"></i>
                  </div>
                  <span> learn </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lego"></i>
                  </div>
                  <span> lego </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lens"></i>
                  </div>
                  <span> lens </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-letter"></i>
                  </div>
                  <span> letter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-letterbox"></i>
                  </div>
                  <span> letterbox </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-library"></i>
                  </div>
                  <span> library </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-license"></i>
                  </div>
                  <span> license </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-life-bouy"></i>
                  </div>
                  <span> life-bouy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-life-buoy"></i>
                  </div>
                  <span> life-buoy </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-life-jacket"></i>
                  </div>
                  <span> life-jacket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-life-ring"></i>
                  </div>
                  <span> life-ring </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-light-bulb"></i>
                  </div>
                  <span> light-bulb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lighter"></i>
                  </div>
                  <span> lighter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lightning-ray"></i>
                  </div>
                  <span> lightning-ray </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-like"></i>
                  </div>
                  <span> like </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-line-height"></i>
                  </div>
                  <span> line-height </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-link-alt"></i>
                  </div>
                  <span> link-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-link"></i>
                  </div>
                  <span> link </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-list"></i>
                  </div>
                  <span> list </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-listening"></i>
                  </div>
                  <span> listening </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-listine-dots"></i>
                  </div>
                  <span> listine-dots </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-listing-box"></i>
                  </div>
                  <span> listing-box </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-listing-number"></i>
                  </div>
                  <span> listing-number </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-live-support"></i>
                  </div>
                  <span> live-support </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-location-arrow"></i>
                  </div>
                  <span> location-arrow </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-location-pin"></i>
                  </div>
                  <span> location-pin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lock"></i>
                  </div>
                  <span> lock </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-login"></i>
                  </div>
                  <span> login </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-logout"></i>
                  </div>
                  <span> logout </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lollipop"></i>
                  </div>
                  <span> lollipop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-long-drive"></i>
                  </div>
                  <span> long-drive </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-look"></i>
                  </div>
                  <span> look </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-loop"></i>
                  </div>
                  <span> loop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-luggage"></i>
                  </div>
                  <span> luggage </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lunch"></i>
                  </div>
                  <span> lunch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-lungs"></i>
                  </div>
                  <span> lungs </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-magic-alt"></i>
                  </div>
                  <span> magic-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-magic"></i>
                  </div>
                  <span> magic </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-magnet"></i>
                  </div>
                  <span> magnet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mail-box"></i>
                  </div>
                  <span> mail-box </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mail"></i>
                  </div>
                  <span> mail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-male"></i>
                  </div>
                  <span> male </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-map-pins"></i>
                  </div>
                  <span> map-pins </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-map"></i>
                  </div>
                  <span> map </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-maximize"></i>
                  </div>
                  <span> maximize </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-measure"></i>
                  </div>
                  <span> measure </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-medicine"></i>
                  </div>
                  <span> medicine </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mega-phone"></i>
                  </div>
                  <span> mega-phone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-megaphone-alt"></i>
                  </div>
                  <span> megaphone-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-megaphone"></i>
                  </div>
                  <span> megaphone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-memorial"></i>
                  </div>
                  <span> memorial </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-memory-card"></i>
                  </div>
                  <span> memory-card </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mic-mute"></i>
                  </div>
                  <span> mic-mute </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mic"></i>
                  </div>
                  <span> mic </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-military"></i>
                  </div>
                  <span> military </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mill"></i>
                  </div>
                  <span> mill </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-minus-circle"></i>
                  </div>
                  <span> minus-circle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-minus-square"></i>
                  </div>
                  <span> minus-square </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-minus"></i>
                  </div>
                  <span> minus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mobile-phone"></i>
                  </div>
                  <span> mobile-phone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-molecule"></i>
                  </div>
                  <span> molecule </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-money"></i>
                  </div>
                  <span> money </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-moon"></i>
                  </div>
                  <span> moon </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mop"></i>
                  </div>
                  <span> mop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-muffin"></i>
                  </div>
                  <span> muffin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-mustache"></i>
                  </div>
                  <span> mustache </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-navigation-menu"></i>
                  </div>
                  <span> navigation-menu </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-navigation"></i>
                  </div>
                  <span> navigation </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-network-tower"></i>
                  </div>
                  <span> network-tower </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-network"></i>
                  </div>
                  <span> network </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-news"></i>
                  </div>
                  <span> news </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-newspaper"></i>
                  </div>
                  <span> newspaper </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-no-smoking"></i>
                  </div>
                  <span> no-smoking </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-not-allowed"></i>
                  </div>
                  <span> not-allowed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-notebook"></i>
                  </div>
                  <span> notebook </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-notepad"></i>
                  </div>
                  <span> notepad </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-notification"></i>
                  </div>
                  <span> notification </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-numbered"></i>
                  </div>
                  <span> numbered </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-opposite"></i>
                  </div>
                  <span> opposite </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-optic"></i>
                  </div>
                  <span> optic </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-options"></i>
                  </div>
                  <span> options </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-package"></i>
                  </div>
                  <span> package </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-page"></i>
                  </div>
                  <span> page </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paint"></i>
                  </div>
                  <span> paint </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paper-plane"></i>
                  </div>
                  <span> paper-plane </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-paperclip"></i>
                  </div>
                  <span> paperclip </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-papers"></i>
                  </div>
                  <span> papers </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pay"></i>
                  </div>
                  <span> pay </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-penguin-linux"></i>
                  </div>
                  <span> penguin-linux </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pestle"></i>
                  </div>
                  <span> pestle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-phone-circle"></i>
                  </div>
                  <span> phone-circle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-phone"></i>
                  </div>
                  <span> phone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-picture"></i>
                  </div>
                  <span> picture </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pine"></i>
                  </div>
                  <span> pine </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-pixels"></i>
                  </div>
                  <span> pixels </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-plugin"></i>
                  </div>
                  <span> plugin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-plus-circle"></i>
                  </div>
                  <span> plus-circle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-plus-square"></i>
                  </div>
                  <span> plus-square </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-plus"></i>
                  </div>
                  <span> plus </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-polygonal"></i>
                  </div>
                  <span> polygonal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-power"></i>
                  </div>
                  <span> power </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-price"></i>
                  </div>
                  <span> price </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-print"></i>
                  </div>
                  <span> print </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-puzzle"></i>
                  </div>
                  <span> puzzle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-qr-code"></i>
                  </div>
                  <span> qr-code </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-queen"></i>
                  </div>
                  <span> queen </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-question-circle"></i>
                  </div>
                  <span> question-circle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-question-square"></i>
                  </div>
                  <span> question-square </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-question"></i>
                  </div>
                  <span> question </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-quote-left"></i>
                  </div>
                  <span> quote-left </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-quote-right"></i>
                  </div>
                  <span> quote-right </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-random"></i>
                  </div>
                  <span> random </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-recycle"></i>
                  </div>
                  <span> recycle </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-refresh"></i>
                  </div>
                  <span> refresh </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-repair"></i>
                  </div>
                  <span> repair </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-reply-all"></i>
                  </div>
                  <span> reply-all </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-reply"></i>
                  </div>
                  <span> reply </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-resize"></i>
                  </div>
                  <span> resize </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-responsive"></i>
                  </div>
                  <span> responsive </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-retweet"></i>
                  </div>
                  <span> retweet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-road"></i>
                  </div>
                  <span> road </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-robot"></i>
                  </div>
                  <span> robot </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-royal"></i>
                  </div>
                  <span> royal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-rss-feed"></i>
                  </div>
                  <span> rss-feed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-safety"></i>
                  </div>
                  <span> safety </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sale-discount"></i>
                  </div>
                  <span> sale-discount </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-satellite"></i>
                  </div>
                  <span> satellite </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-send-mail"></i>
                  </div>
                  <span> send-mail </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-server"></i>
                  </div>
                  <span> server </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-settings-alt"></i>
                  </div>
                  <span> settings-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-settings"></i>
                  </div>
                  <span> settings </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-share-alt"></i>
                  </div>
                  <span> share-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-share-boxed"></i>
                  </div>
                  <span> share-boxed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-share"></i>
                  </div>
                  <span> share </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-shield"></i>
                  </div>
                  <span> shield </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-shopping-cart"></i>
                  </div>
                  <span> shopping-cart </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sign-in"></i>
                  </div>
                  <span> sign-in </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sign-out"></i>
                  </div>
                  <span> sign-out </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-signal"></i>
                  </div>
                  <span> signal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-site-map"></i>
                  </div>
                  <span> site-map </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-smart-phone"></i>
                  </div>
                  <span> smart-phone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-soccer"></i>
                  </div>
                  <span> soccer </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sort-alt"></i>
                  </div>
                  <span> sort-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-sort"></i>
                  </div>
                  <span> sort </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-space"></i>
                  </div>
                  <span> space </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spanner"></i>
                  </div>
                  <span> spanner </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-speech-comments"></i>
                  </div>
                  <span> speech-comments </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-speed-meter"></i>
                  </div>
                  <span> speed-meter </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spinner-alt-1"></i>
                  </div>
                  <span> spinner-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spinner-alt-2"></i>
                  </div>
                  <span> spinner-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spinner-alt-3"></i>
                  </div>
                  <span> spinner-alt-3 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spinner-alt-4"></i>
                  </div>
                  <span> spinner-alt-4 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spinner-alt-5"></i>
                  </div>
                  <span> spinner-alt-5 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spinner-alt-6"></i>
                  </div>
                  <span> spinner-alt-6 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spinner"></i>
                  </div>
                  <span> spinner </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-spreadsheet"></i>
                  </div>
                  <span> spreadsheet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-square"></i>
                  </div>
                  <span> square </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ssl-security"></i>
                  </div>
                  <span> ssl-security </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-star-alt-1"></i>
                  </div>
                  <span> star-alt-1 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-star-alt-2"></i>
                  </div>
                  <span> star-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-star"></i>
                  </div>
                  <span> star </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-street-view"></i>
                  </div>
                  <span> street-view </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-support-faq"></i>
                  </div>
                  <span> support-faq </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tack-pin"></i>
                  </div>
                  <span> tack-pin </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tag"></i>
                  </div>
                  <span> tag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tags"></i>
                  </div>
                  <span> tags </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tasks-alt"></i>
                  </div>
                  <span> tasks-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tasks"></i>
                  </div>
                  <span> tasks </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-telephone"></i>
                  </div>
                  <span> telephone </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-telescope"></i>
                  </div>
                  <span> telescope </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-terminal"></i>
                  </div>
                  <span> terminal </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thumbs-down"></i>
                  </div>
                  <span> thumbs-down </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-thumbs-up"></i>
                  </div>
                  <span> thumbs-up </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tick-boxed"></i>
                  </div>
                  <span> tick-boxed </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tick-mark"></i>
                  </div>
                  <span> tick-mark </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-ticket"></i>
                  </div>
                  <span> ticket </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tie"></i>
                  </div>
                  <span> tie </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toggle-off"></i>
                  </div>
                  <span> toggle-off </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-toggle-on"></i>
                  </div>
                  <span> toggle-on </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tools-alt-2"></i>
                  </div>
                  <span> tools-alt-2 </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tools"></i>
                  </div>
                  <span> tools </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-touch"></i>
                  </div>
                  <span> touch </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-traffic-light"></i>
                  </div>
                  <span> traffic-light </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-transparent"></i>
                  </div>
                  <span> transparent </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-tree"></i>
                  </div>
                  <span> tree </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-unique-idea"></i>
                  </div>
                  <span> unique-idea </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-unlock"></i>
                  </div>
                  <span> unlock </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-unlocked"></i>
                  </div>
                  <span> unlocked </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-upload-alt"></i>
                  </div>
                  <span> upload-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-upload"></i>
                  </div>
                  <span> upload </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-usb-drive"></i>
                  </div>
                  <span> usb-drive </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-usb"></i>
                  </div>
                  <span> usb </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-vector-path"></i>
                  </div>
                  <span> vector-path </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-verification-check"></i>
                  </div>
                  <span> verification-check </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wall-clock"></i>
                  </div>
                  <span> wall-clock </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wall"></i>
                  </div>
                  <span> wall </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wallet"></i>
                  </div>
                  <span> wallet </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-warning-alt"></i>
                  </div>
                  <span> warning-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-warning"></i>
                  </div>
                  <span> warning </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-water-drop"></i>
                  </div>
                  <span> water-drop </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-web"></i>
                  </div>
                  <span> web </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wheelchair"></i>
                  </div>
                  <span> wheelchair </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wifi-alt"></i>
                  </div>
                  <span> wifi-alt </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-wifi"></i>
                  </div>
                  <span> wifi </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-world"></i>
                  </div>
                  <span> world </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-zigzag"></i>
                  </div>
                  <span> zigzag </span>
                </div>
              </li>

              <li>
                <div class="icon-holder">
                  <div class="icon">
                    <i class="icofont-zipped"></i>
                  </div>
                  <span> zipped </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>
